/* eslint-disable */
import { Message } from 'element-ui'
import EventBus from './EventBus'
import {
  e5,
  MediacloudReporter,
  MediaCloudGateway
} from 'common-mediax/src/apis'
import md5 from 'md5'
import store from '@/store'
import { serviceLocation as service } from '@common'
import { sm3 } from 'sm-crypto'
import { getRandom11DigitNumber } from 'common-mediax/src/common/sm2'
const yqMagicCubeCreatorLogo = window.localStorage.getItem(
  'yqMagicCubeCreatorLogo'
)
const yqMagicCubeCreatorName =
  window.localStorage.getItem('yqMagicCubeCreatorName') || '魔方AI'
// 增加一些自定义按钮，用于触发自定义事件，部分按钮复用原来按钮的图片。
function registerUIList(UE, customConfig) {
  let registerUIList = [
    {
      uiName: 'insertimage1',
      className: 'edui-for-insertimage',
      title: '插入图片'
    },
    {
      uiName: 'insertvideo1',
      className: 'edui-for-insertvideo',
      title: '插入视频'
    },
    {
      uiName: 'insertaudio1',
      className: 'edui-for-insertaudio',
      title: '插入音频'
    },
    {
      uiName: 'searchreplace1',
      className: 'edui-for-searchreplace',
      title: '替换查询'
    },
    {
      uiName: 'link1',
      className: 'edui-for-link',
      title: '超链接'
    },
    {
      uiName: 'anchor1',
      className: 'edui-for-anchor',
      title: '锚点'
    },
    {
      uiName: 'insertframe1',
      className: 'edui-for-insertframe',
      title: '插入Iframe'
    },
    {
      uiName: 'help1',
      className: 'edui-for-help',
      title: '帮助'
    },
    {
      uiName: 'spechars1',
      className: 'edui-for-spechars',
      title: '特殊字符'
    },
    {
      uiName: 'wordexport',
      cssRules: 'background-position: -300px -40px;',
      title: '导入文档'
    },
    {
      uiName: 'savedrafts',
      className: 'edui-for-drafting',
      title: '暂存',
      label: '暂存'
    },
    {
      uiName: 'showdrafts',
      className: 'edui-for-drafts',
      title: '暂存箱',
      label: '暂存箱'
    },
    {
      uiName: 'showversions',
      className: 'edui-for-versions',
      title: '版本管理',
      label: '版本管理'
    },
    {
      uiName: 'p2br',
      className: 'edui-for-p2br',
      title: '换段转换行',
      label: '换段转换行'
    },
    {
      uiName: 'br2p',
      className: 'edui-for-br2p',
      title: '换行转换段',
      label: '换行转换段'
    },
    {
      uiName: 'pagebreak',
      className: 'edui-for-pagebreak',
      title: '分页',
      label: '分页'
    },
    {
      uiName: 'showmfai',
      className: 'edui-for-showmfai',
      cssRules: yqMagicCubeCreatorLogo
        ? `background-image: url(${yqMagicCubeCreatorLogo}) !important;`
        : '',
      title: yqMagicCubeCreatorName,
      label: yqMagicCubeCreatorName
    }
  ]
  if (customConfig.commentable) {
    registerUIList.push({
      uiName: 'comments',
      cssRules: 'background-position: -778px -77px;',
      title: '插入批注'
    })
  }
  // 自定义ui按钮
  registerUIList.forEach((uiBtn) => {
    UE.registerUI(uiBtn.uiName, function (editor, uiName) {
      // 创建一个button
      var btn = new UE.ui.Button({
        // 按钮的名字
        name: uiName,
        className: uiBtn.className || '',
        // 提示
        title: uiBtn.title,
        label: uiBtn.label ? uiBtn.label : '',
        // 添加额外样式，指定icon图标，这里默认使用一个重复的icon
        cssRules: uiBtn.cssRules || '',
        // 点击时执行的命令
        onclick: function () {
          // 这里可以不用执行命令,做你自己的操作也可
          editor.execCommand(uiName)
        }
      })
      // 当点到编辑内容上时，按钮要做的状态反射
      editor.addListener('selectionchange', function () {
        var state = editor.queryCommandState(uiName)
        if (state === -1) {
          btn.setDisabled(true)
          btn.setChecked(false)
        } else {
          btn.setDisabled(false)
          btn.setChecked(state)
        }
      })
      // 因为你是添加button,所以需要返回这个button
      return btn
    })
  })
}

// 判断某个元素的祖先元素是否存在批注元素
function exitComments(node) {
  let parentNode = node.parentNode
  if (parentNode.tagName.toLowerCase() === 'body') {
    return false
  }
  if (parentNode.hasAttribute('founder-mediacloud-comment-id')) {
    return parentNode.getAttribute('founder-mediacloud-comment-id')
  }
  return exitComments(parentNode)
}

function customCommands(UE) {
  let p = UE.utils
  let r = window.baidu || {}
  /* let f = r.editor.dom.domUtils */
  let f = UE.dom.domUtils
  let proofLastClassName = ''

  // AI 魔方右键
  UE.commands['mfai'] = {
    execCommand: function (cmd, id) {
      this.execCommand('mfaigeneratetext', id)
      return
    }
  }

  // 插入批注
  UE.commands['onlinephotos'] = {
    execCommand: function () {
      var me = this
      var node = me.selection.getRange()
      if (!node.collapsed) {
        var bookmark = node.createBookmark()
        var html = me.getContent()
        var selectedHtml = html
          .split(bookmark.start.outerHTML)[1]
          .split(bookmark.end.outerHTML)[0]
        // console.log('selectedHtml:', selectedHtml);

        let pNode = me.document.createElement('p')
        pNode.innerHTML = selectedHtml
          .replace(/<\/p>/g, 'nextNfillChar</p>')
          .replace(/<\/div>/g, 'nextNfillChar</div>')
          .replace(/<br\/?>/gi, 'nextNfillChar<br>')

        EventBus.$emit('openOnlinePhotos', pNode.innerText)
        // 移除书签
        node.moveToBookmark(bookmark)
        // 向当前选区的结束处闭合选区
        // node.collapse()
      }
      return
    }
  }
  // 插入批注
  UE.commands['comments'] = {
    execCommand: function () {
      // 移除监听编辑器内容改变
      this.removeListener('contentChange', window.UE.removeComment)

      // 触发插入批注事件后，首先使右侧label打开批注tab页
      EventBus.$emit('openComment')
      var me = this
      var node = me.selection.getRange()
      if (node.collapsed) {
        Message({
          showClose: true,
          message: '请选择需要批注的文字',
          type: 'error'
        })
        // 监听编辑器内容改变
        this.addListener('contentChange', window.UE.removeComment)
      } else {
        // 添加书签，通过添加书签的方式获取到选中区域的html
        var bookmark = node.createBookmark()
        var html = me.getContent()
        var selectedHtml = html
          .split(bookmark.start.outerHTML)[1]
          .split(bookmark.end.outerHTML)[0]

        // 过滤掉选中区域的所有标签及空白字符，如果字符串为空，则给出提示
        var selectedText = selectedHtml.replace(/\s|(<.*?>)|(&nbsp;)/g, '')
        if (!selectedText) {
          Message({
            showClose: true,
            message: '请选择需要批注的文字',
            type: 'error'
          })
          // 移除书签
          node.moveToBookmark(bookmark)
          // 向当前选区的结束处闭合选区
          node.collapse()
          setTimeout(() => {
            // 监听编辑器内容改变
            me.addListener('contentChange', window.UE.removeComment)
          }, 500)
          return
        }

        // 批注重叠有四种情况：1.选中区域包含完整的批注标签。2.选中区域被包含在批注标签内。3.选中区域只包含批注标签的打开标签。4.选中区域只包含批注标签的结束标签。

        // 思路：1.判断选中区域内是否有批注的打开标签-可以解决情况1、3。2.书签的开始部分的祖先元素是否有批注元素-可以解决情况2、4。

        // 1.判断选中区域内是否有批注的开始标签
        if (selectedHtml.indexOf('founder-mediacloud-comment-id') !== -1) {
          Message({
            showClose: true,
            message: '选中的内容已添加批注',
            type: 'error'
          })
          // 移除书签
          node.moveToBookmark(bookmark)
          // 向当前选区的结束处闭合选区
          node.collapse()
          setTimeout(() => {
            // 监听编辑器内容改变
            me.addListener('contentChange', window.UE.removeComment)
          }, 500)
          return
        }

        // 2.书签的开始部分的祖先元素是否有批注元素
        if (exitComments(bookmark.start)) {
          Message({
            showClose: true,
            message: '选中的内容已添加批注',
            type: 'error'
          })
          // 移除书签
          node.moveToBookmark(bookmark)
          // 向当前选区的结束处闭合选区
          node.collapse()
          setTimeout(() => {
            // 监听编辑器内容改变
            me.addListener('contentChange', window.UE.removeComment)
          }, 500)
          return
        }

        // 移除书签
        node.moveToBookmark(bookmark)

        var id = '_' + new Date().getTime() + '_' // 这个属性用于存储批注id
        // 如果用span元素会出现嵌套span元素导致编辑器出现各种问题，精挑细选后决定使用label元素，如果编辑器里原来就有label标签，会出BUG。尝试拼接html，使用自定义标签，但会截断原有标签导致出现BUG。
        node.applyInlineStyle('label', {
          'founder-mediacloud-comment-id': id
        })
        // node.select() // 这行代码影响选区闭合了，不知道当初为啥加这行代码，先去掉，看看有没有别的影响
        html = me.getContent()
        var reg = new RegExp(`founder-mediacloud-comment-id="(_\\d*_)"`, 'g')
        var idArr = html.match(reg)
        var index = idArr.lastIndexOf(
          `founder-mediacloud-comment-id="` + id + `"`
        )
        var nextId = -1
        if (index !== idArr.length - 1) {
          nextId = idArr[index + 1].match(/_\d*_/)[0]
        }
        EventBus.$emit('insertComment', { id: id, nextId: nextId })
        // 向当前选区的结束处闭合选区
        node.collapse()
        setTimeout(() => {
          // 监听编辑器内容改变
          me.addListener('contentChange', window.UE.removeComment)
        }, 500)
      }
    }
  }
  UE.commands['shears'] = {
    execCommand: function () {
      window.uuuu = this
      var me = this
      var range = me.selection.getRange()

      if (range.collapsed) {
        // 没有选中内容时不执行操作
        return
      }

      try {
        // 1. 保存选中内容到剪贴板
        me.execCommand('copy')
        // 2. 删除选中内容
        range.deleteContents()
      } catch (e) {
        console.error('剪切操作失败:', e)
        // 兼容性处理：提示用户使用快捷键
        Message({
          showClose: true,
          message: '浏览器不支持直接剪切，请使用 Ctrl+X 快捷键',
          type: 'warning'
        })
      }
    }
  }
  UE.commands['deletes'] = {
    execCommand: function () {
      window.alert("浏览器不支持,请使用'backspace'或'delete'")
    }
  }

  // 删除一条批注
  UE.commands['deletecomments'] = {
    execCommand: function (cmd, id) {
      var me = this
      var html = me.getContent()
      // 如果出现label嵌套的情况会出现BUG。由于js不支持正则表达式的平衡组语法，所以此问题暂时无法解决。
      var reg = new RegExp(
        `<label founder\-mediacloud\-comment\-id="` + id + `">(.*?)</label>`,
        'g'
      )
      html = html.replace(reg, '$1')
      me.setContent(html)
    }
  }
  // 删除所有批注
  UE.commands['deleteallcomments'] = {
    execCommand: function () {
      var me = this
      var html = me.getContent()
      // 如果出现label嵌套的情况会出现BUG。由于js不支持正则表达式的平衡组语法，所以此问题暂时无法解决。
      var reg = new RegExp(
        `<label founder\-mediacloud\-comment\-id="_\\d*_">(.*?)</label>`,
        'g'
      )
      html = html.replace(reg, '$1')
      me.setContent(html)
    }
  }
  // 编辑器光标在批注标签内时，选中批注tab页对应批注并滚动到这个批注的位置
  UE.commands['selectcomments'] = {
    execCommand: function () {
      var me = this
      var node = me.selection.getRange()
      if (node.collapsed) {
        // 只有在选中区域闭合，既没有选中任何内容时才执行下面代码
        // 添加书签
        var bookmark = node.createBookmark()
        // 书签的祖先元素是否有批注元素，如果有则抛出id
        let commentsId = exitComments(bookmark.start)
        if (commentsId) {
          EventBus.$emit('selectComment', commentsId)
        }
        // 移除书签
        node.moveToBookmark(bookmark)
      }
    }
  }
  // 批注tab页中某个批注获得焦点时，编辑器内对应批注修改背景色，并将此批注滚动到可视区
  UE.commands['markcomments'] = {
    execCommand: function (cmd, id) {
      // 移除监听编辑器内容改变
      this.removeListener('contentChange', window.UE.removeComment)
      var me = this
      // var html = me.getContent()
      // var reg = new RegExp(`founder\-mediacloud\-comment\-id="` + id + `"`, 'g')
      // html = html.replace(reg, `founder-mediacloud-comment-id-mark="` + id + `"`)
      // me.setContent(html)
      let innerDocument = me.iframe.contentWindow.document
      let domList = innerDocument.querySelectorAll(
        'label[founder-mediacloud-comment-id="' + id + '"]'
      )
      domList.forEach((dom) => {
        dom.removeAttribute('founder-mediacloud-comment-id')
        dom.setAttribute('founder-mediacloud-comment-id-mark', id)
      })

      setTimeout(() => {
        // 将当前元素滚动到可视区域
        domList[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'start'
        })
        // 监听编辑器内容改变
        me.addListener('contentChange', window.UE.removeComment)
      }, 500)
    }
  }
  // 还原标注tab页选中的批注，修改此批注对应的属性名
  UE.commands['restoremarkcomments'] = {
    execCommand: function (cmd, id) {
      // 移除监听编辑器内容改变
      this.removeListener('contentChange', window.UE.removeComment)
      var me = this
      var html = me.getContent()
      var reg = new RegExp(
        `founder\-mediacloud\-comment\-id\-mark="` + id + `"`,
        'g'
      )
      html = html.replace(reg, `founder-mediacloud-comment-id="` + id + `"`)
      me.setContent(html)
      setTimeout(() => {
        // 监听编辑器内容改变
        me.addListener('contentChange', window.UE.removeComment)
      }, 500)
    }
  }

  // 更新图说
  UE.commands['refreshimagecomment'] = {
    execCommand: function (cmd, ids) {
      var me = this
      let pNodes = f.getElementsByTagName(me.document.body, 'p')
      let innerDocument = me.iframe.contentWindow.document
      pNodes.forEach((p) => {
        if ($(p).attr('founder-image-comment-id')) {
          let commentid = $(p).attr('founder-image-comment-id')
          let imgdom = innerDocument.getElementById(commentid)
          if (
            ids.includes(commentid) &&
            imgdom &&
            $(p).text() !== $(imgdom).attr('title')
          ) {
            imgdom.setAttribute('title', $(p).text())
          }
        }
      })
    }
  }
  // 删除图说
  UE.commands['deleteimagecomment'] = {
    execCommand: function (cmd, ids) {
      var me = this
      let pNodes = f.getElementsByTagName(me.document.body, 'p')
      pNodes.forEach((p) => {
        if ($(p).attr('founder-image-comment-id')) {
          let commentid = $(p).attr('founder-image-comment-id')
          if (ids.includes(commentid)) {
            // f.remove(p, true)
            $(p).remove()
          }
        }
      })
    }
  }
  // 图说
  UE.commands['imagecomment'] = {
    execCommand: function (cmd, id, title, isApplyOthers) {
      var me = this
      let pNodes = f.getElementsByTagName(me.document.body, 'p')
      let commentNodes = [],
        commentIds = []

      pNodes.forEach((p) => {
        if ($(p).attr('founder-image-comment-id')) {
          commentIds.push($(p).attr('founder-image-comment-id'))
          commentNodes.push(p)
        }
      })
      if (isApplyOthers) {
        let nodes = f.getElementsByTagName(me.document.body, 'img')
        if (title) {
          nodes.forEach((element) => {
            element.setAttribute('title', title)
            if (
              element.parentNode &&
              element.parentNode.tagName.toLowerCase() === 'p'
            ) {
              // 如果已经有图说p标签，则直接修改内容
              if (
                commentIds.includes(element.id) ||
                commentIds.includes(element.id + '')
              ) {
                commentNodes.find((p) => {
                  if (
                    $(p).attr('founder-image-comment-id') === element.id ||
                    $(p).attr('founder-image-comment-id') === element.id + ''
                  ) {
                    $(p).html(title)
                    return true
                  }
                })
              } else {
                // 如果还没有图说p标签则添加p标签
                let pNode = me.document.createElement('p')
                pNode.innerHTML = title
                // 设置图说id及样式
                f.setAttributes(pNode, {
                  'founder-image-comment-id': element.id,
                  style: 'text-align:center;font-size:13px;color:#777777;'
                })
                f.insertAfter(element.parentNode, pNode)
              }
            }
          })
        } else {
          nodes.forEach((element) => {
            element.setAttribute('title', '')
            if (
              commentIds.includes(element.id) ||
              commentIds.includes(element.id + '')
            ) {
              commentNodes.find((p) => {
                if (
                  $(p).attr('founder-image-comment-id') === element.id ||
                  $(p).attr('founder-image-comment-id') === element.id + ''
                ) {
                  $(p).remove()
                  return true
                }
              })
            }
          })
        }
      } else {
        var myImage = getSpecialImage(me, id)

        if (myImage) myImage.setAttribute('title', title || '')
        else return
        if (
          myImage.parentNode &&
          myImage.parentNode.tagName.toLowerCase() === 'p'
        ) {
          // 如果已经有图说p标签，则直接修改内容
          if (commentIds.includes(id) || commentIds.includes(id + '')) {
            let pNode = commentNodes.find((p) => {
              if (
                $(p).attr('founder-image-comment-id') === id ||
                $(p).attr('founder-image-comment-id') === id + ''
              ) {
                return true
              }
            })
            if (pNode) {
              // console.log('pNode', pNode);
              if (title) {
                $(pNode).html(title)
              } else {
                $(pNode).remove()
              }
            }
          } else if (title) {
            // 如果还没有图说p标签则添加p标签
            let pNode = me.document.createElement('p')
            pNode.innerHTML = title
            // 设置图说id及样式
            f.setAttributes(pNode, {
              'founder-image-comment-id': id,
              style: 'text-align:center;font-size:13px;color:#777777;'
            })
            f.insertAfter(myImage.parentNode, pNode)
          }
        }
      }
    }
  }

  // 更新视频说明
  UE.commands['refreshvideocomment'] = {
    execCommand: function (cmd, ids) {
      var me = this
      let pNodes = f.getElementsByTagName(me.document.body, 'p')
      let innerDocument = me.iframe.contentWindow.document
      pNodes.forEach((p) => {
        if ($(p).attr('founder-video-comment-id')) {
          let commentid = $(p).attr('founder-video-comment-id')
          let videodom = innerDocument.getElementById(commentid)
          if (
            ids.includes(commentid) &&
            videodom &&
            $(p).text() !== $(videodom).attr('title')
          ) {
            videodom.setAttribute('title', $(p).text())
          }
        }
      })
    }
  }
  // 删除视频说明
  UE.commands['deletevideocomment'] = {
    execCommand: function (cmd, ids) {
      var me = this
      let pNodes = f.getElementsByTagName(me.document.body, 'p')
      pNodes.forEach((p) => {
        if ($(p).attr('founder-video-comment-id')) {
          let commentid = $(p).attr('founder-video-comment-id')
          if (ids.includes(commentid)) {
            // f.remove(p, true)
            $(p).remove()
          }
        }
      })
    }
  }
  // 视频说明
  UE.commands['videocomment'] = {
    execCommand: function (cmd, id, title, isApplyOthers) {
      var me = this
      let pNodes = f.getElementsByTagName(me.document.body, 'p')
      let commentNodes = [],
        commentIds = []

      pNodes.forEach((p) => {
        if ($(p).attr('founder-video-comment-id')) {
          commentIds.push($(p).attr('founder-video-comment-id'))
          commentNodes.push(p)
        }
      })
      if (isApplyOthers) {
        let nodes = f.getElementsByTagName(me.document.body, 'video')
        if (title) {
          nodes.forEach((element) => {
            element.setAttribute('title', title)
            if (
              element.parentNode &&
              element.parentNode.tagName.toLowerCase() === 'p'
            ) {
              // 如果已经有图说p标签，则直接修改内容
              if (
                commentIds.includes(element.id) ||
                commentIds.includes(element.id + '')
              ) {
                commentNodes.find((p) => {
                  if (
                    $(p).attr('founder-video-comment-id') === element.id ||
                    $(p).attr('founder-video-comment-id') === element.id + ''
                  ) {
                    $(p).html(title)
                    return true
                  }
                })
              } else {
                // 如果还没有图说p标签则添加p标签
                let pNode = me.document.createElement('p')
                pNode.innerHTML = title
                // 设置图说id及样式
                f.setAttributes(pNode, {
                  'founder-video-comment-id': element.id,
                  style: 'text-align:center;font-size:13px;color:#777777;'
                })
                f.insertAfter(element.parentNode, pNode)
              }
            }
          })
        } else {
          nodes.forEach((element) => {
            element.setAttribute('title', '')
            if (
              commentIds.includes(element.id) ||
              commentIds.includes(element.id + '')
            ) {
              commentNodes.find((p) => {
                if (
                  $(p).attr('founder-video-comment-id') === element.id ||
                  $(p).attr('founder-video-comment-id') === element.id + ''
                ) {
                  $(p).remove()
                  return true
                }
              })
            }
          })
        }
      } else {
        var myVideo = getSpecialVideo(me, id)

        if (myVideo) myVideo.setAttribute('title', title || '')
        else return
        if (
          myVideo.parentNode &&
          myVideo.parentNode.tagName.toLowerCase() === 'p'
        ) {
          // 如果已经有视频说明p标签，则直接修改内容
          if (commentIds.includes(id) || commentIds.includes(id + '')) {
            let pNode = commentNodes.find((p) => {
              if (
                $(p).attr('founder-video-comment-id') === id ||
                $(p).attr('founder-video-comment-id') === id + ''
              ) {
                return true
              }
            })
            if (pNode) {
              // console.log('pNode', pNode);
              if (title) {
                $(pNode).html(title)
              } else {
                $(pNode).remove()
              }
            }
          } else if (title) {
            // 如果还没有图说p标签则添加p标签
            let pNode = me.document.createElement('p')
            pNode.innerHTML = title
            // 设置图说id及样式
            f.setAttributes(pNode, {
              'founder-video-comment-id': id,
              style: 'text-align:center;font-size:13px;color:#777777;'
            })
            f.insertAfter(myVideo.parentNode, pNode)
          }
        }
      }
    }
  }
  // 描述
  UE.commands['desccomment'] = {
    execCommand: function (cmd, id, title, isApplyOthers) {
      var me = this
      if (isApplyOthers) {
        var imgs = this.document.querySelectorAll('img')
        Array.prototype.forEach.call(imgs, function (img) {
          img.setAttribute('desc', title || '')
        })
      } else {
        var myImage = getSpecialImage(me, id)
        if (myImage) myImage.setAttribute('desc', title || '')
      }
    }
  }
  // 网站分页
  UE.commands['pagebreak'] = {
    execCommand: function () {
      let html = `<hr class="ueditor_page_break_tag">`
      this.execCommand('inserthtml', html, !0)
    }
  }

  function getSpecialImage(_this, id) {
    var myImage
    var node = _this.selection.getRange()
    // 选中图片
    let result = false
    // let all = Array.prototype.slice.call(node.document.all)

    let nodes = f.getElementsByTagName(_this.document.body, 'img')
    nodes.forEach((element) => {
      if (result) {
        return
      }
      if (element.id === id.toString()) {
        myImage = element
        result = true
      }
    })
    return myImage
  }
  function getSpecialVideo(_this, id) {
    var myVideo
    var node = _this.selection.getRange()
    // 选中视频
    let result = false
    // let all = Array.prototype.slice.call(node.document.all)

    let nodes = f.getElementsByTagName(_this.document.body, 'video')
    nodes.forEach((element) => {
      if (result) {
        return
      }
      if (element.id === id.toString()) {
        myVideo = element
        result = true
      }
    })
    return myVideo
  }
  UE.commands.insertimage = {
    execCommand: function (d, b) {
      b = p.isArray(b) ? b : [b]

      if (b.length) {
        d = this.selection.getRange()
        var c = d.getClosedNode()

        if (!0 !== this.fireEvent('beforeinsertimage', b)) {
          if (
            !c ||
            !/img/i.test(c.tagName) ||
            (c.className === 'edui-faked-video' &&
              c.className.indexOf('edui-upload-video') === -1) ||
            c.getAttribute('word_img')
          ) {
            d = []
            var a = b[0]
            if (b.length === 1) {
              c =
                '<img src="' +
                a.src +
                '" ' +
                (a._src ? ' mam="' + a._src + '" ' : '') +
                (a.sourceid ? ' sourceid="' + a.sourceid + '" ' : '') +
                (a.groupid ? ' groupid="' + a.groupid + '" ' : '') +
                (a.width ? 'width="' + a.width + '" ' : '') +
                (a.height ? ' height="' + a.height + '" ' : '') +
                'style="max-width:100%;height:auto;"' +
                (a.aid ? ' aid="' + a.aid + '" ' : '') +
                (a.imageid ? ' id="' + a.imageid + '" ' : '') +
                /* (a.title && a.title !== '' ? ' title="' + a.title + '"' : '') + */
                (a.content && a.content !== ''
                  ? ' title="' + a.content + '"'
                  : '') +
                (a.border && a.border !== '0'
                  ? ' border="' + a.border + '"'
                  : '') +
                (a.alt && a.alt !== '' ? ' alt="' + a.alt + '"' : '') +
                (a.hspace && a.hspace !== '0'
                  ? ' hspace = "' + a.hspace + '"'
                  : '') +
                (a.vspace && a.vspace !== '0'
                  ? ' vspace = "' + a.vspace + '"'
                  : '') +
                '>'

              if (!a.floatStyle) {
                a.floatStyle = 'center'
              }
              c = '<p style="text-align: ' + a.floatStyle + '">' + c + '</p>'
              // } else {
              //   c = '<p>' + c + '</p>'
              // }

              d.push(c)
            } else {
              var g = 0

              for (g; a; g++) {
                c =
                  '<p ' +
                  (a.floatStyle === 'center'
                    ? 'style="text-align: center" '
                    : '') +
                  '><img src="' +
                  a.src +
                  '" ' +
                  (a.width ? 'width="' + a.width + '" ' : '') +
                  (a._src ? ' mam="' + a._src + '" ' : '') +
                  (a.sourceid ? ' sourceid="' + a.sourceid + '" ' : '') +
                  (a.groupid ? ' groupid="' + a.groupid + '" ' : '') +
                  (a.height ? ' height="' + a.height + '" ' : '') +
                  'style="max-width:100%;height:auto;"' +
                  (a.aid ? ' aid="' + a.aid + '" ' : '') +
                  (a.imageid ? ' id="' + a.imageid + '" ' : '') +
                  (a.floatStyle && a.floatStyle !== 'center'
                    ? 'float:' + a.floatStyle + ';'
                    : '') +
                  (a.border || '') +
                  '" ' +
                  /* (a.title ? ' title="' + a.title + '"' : '') + */
                  (a.content ? ' title="' + a.content + '"' : '') +
                  ' /></p>'
                d.push(c)
                a = b[g]
              }
            }

            this.execCommand('insertHtml', d.join(''), !0)
            /* 只有这里可能有问题 */
            if (a.content && a.content !== '') {
              this.execCommand(
                'imagecomment',
                a.id || a.imageid,
                a.content,
                false
              )
            }
          } else if (/img/i.test(c.tagName)) {
            a = b.shift()
            a.mam = a._src
            f.setAttributes(c, a)
            this.execCommand('insertimage', b)
          } else {
            a = b.shift()
            g = a.floatStyle
            delete a.floatStyle
            f.setAttributes(c, a)
            this.execCommand('imagefloat', g)
            if (b.length > 0) {
              d.setStartAfter(c).setCursor(!1, !0)
              this.execCommand('insertimage', b)
            }
          }

          this.fireEvent('afterinsertimage', b)
        }
      }
    }
  }
  // 删除图片
  UE.commands['imagedelete'] = {
    execCommand: function (cmd, id) {
      var me = this
      var images = me.iframe.contentWindow.document.images
      var img
      for (var i = 0; i < images.length; i++) {
        if (images[i].id + '' === id + '') {
          img = images[i]
          break
        }
      }
      // var myImage = getImage(me);
      if (img) {
        if (confirm('是否删除图片？')) {
          img.remove()
          // myImage.remove();
        }
      }
    }
  }
  // 删除视频
  UE.commands['deletevideo'] = {
    execCommand: function (cmd, target) {
      r.editor.dom.domUtils.remove(target)
    }
  }
  // 设置视频标题图
  UE.commands['settitlepic'] = {
    execCommand: function (cmd, target) {
      EventBus.$emit('openSetTitlePic', target)
    }
  }
  // 设置视频说明
  UE.commands['setvideocomment'] = {
    execCommand: function (cmd, target) {
      EventBus.$emit('openVideocomment', target)
    }
  }
  // 删除音频
  UE.commands['deletemusic'] = {
    execCommand: function (cmd, target) {
      r.editor.dom.domUtils.remove(target)
    }
  }
  /**
   * 黑马校对-修改并定位当前高亮位置
   * @type {{execCommand: execCommand}}
   */
  UE.commands['articleproof'] = {
    /**
     * @param cmd
     * @param id 当前高亮元素的id
     */
    execCommand: function (cmd, id) {
      let me = this
      let innerDocument = me.iframe.contentWindow.document
      let dom
      if (id) {
        dom = innerDocument.getElementById(id)
      }
      let eles = innerDocument.getElementsByClassName(
        'article-proof-founder-current'
      )
      // 去掉上一个高亮元素的高亮
      if (eles) {
        ;[].forEach.call(eles, (ele) => {
          f.removeAttributes(ele, 'class')
          f.setAttributes(ele, { class: proofLastClassName })
        })
      }

      if (!dom || !id) return

      proofLastClassName = dom.className
      // 高亮当前元素
      f.setAttributes(dom, { class: 'article-proof-founder-current' })

      // 将光标定位到当前高亮元素之后
      // 1、先将编辑器中的光标focus
      this.focus()
      // 2、定义一个新的光标Range
      let range = new UE.dom.Range(me.document)
      // 3、设置光标的起始位置和结束位置，并且设置为闭合，最后选中来显示光标
      range.setStartAfter(dom).setEndAfter(dom).collapse(false).select()
      // 将当前元素滚动到可视区域
      dom.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      })
    }
  }

  /**
   * 方正审校校对-修改并定位当前高亮位置
   * @type {{execCommand: execCommand}}
   */
  UE.commands['articlereplaceproof'] = {
    /**
     * @param cmd
     * @param id 当前高亮元素的id
     * @param text 当前高亮元素的需要替换的文本
     * @param oriText 当前高亮元素的的原始审校文本
     */
    execCommand: function (cmd, id, text, oriText) {
      let me = this
      let innerDocument = me.iframe.contentWindow.document
      let dom

      if (id) {
        dom = innerDocument.getElementById(id)
      }

      let eles = innerDocument.getElementsByClassName(
        'article-proof-founder-current'
      )
      // 去掉上一个高亮元素的高亮
      if (eles) {
        ;[].forEach.call(eles, (ele) => {
          f.removeAttributes(ele, 'class')
          f.setAttributes(ele, { class: proofLastClassName })
        })
      }

      if (!dom || !id) {
        Message({
          showClose: true,
          message: '原始内容可能已被修改或者替换，建议您手动复核',
          type: 'warning'
        })
        return
      }

      proofLastClassName = dom.className

      // 将光标定位到当前高亮元素之后
      // 1、先将编辑器中的光标focus
      this.focus()

      // 将当前元素滚动到可视区域
      dom.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      })
      if (dom.innerText !== oriText) {
        Message({
          showClose: true,
          message: '待采用内容与校对反馈内容有差异，建议您手动复核',
          type: 'warning'
        })
        return
      } else {
        dom.outerHTML = text
      }
    }
  }
}
function customPlugins(UE, customConfig) {
  let p = UE.utils
  let f = window.baidu.editor.dom.domUtils

  UE.plugins.video = function () {
    function d(a, b, d, e, l, k, f, title, poster) {
      let g = ''
      switch (f) {
        case 'embed':
          g =
            '<embed type="application/x-shockwave-flash" class="' +
            k +
            '" pluginspage="http://www.macromedia.com/go/getflashplayer" src="' +
            p.html(a) +
            '" width="' +
            b +
            '" height="' +
            d +
            '"' +
            (l ? ' style="float:' + l + '"' : '') +
            ' wmode="transparent" play="true" loop="false" menu="false" ' +
            'allowscriptaccess="never" allowfullscreen="true" >'
          break
        case 'video':
          f = a.substr(a.lastIndexOf('.') + 1)
          f === 'ogv' && (f = 'ogg')
          g =
            '<video style="max-width:100%;background-color: black;"' +
            (e ? ' id="' + e + '"' : '') +
            (title ? 'title="' + title + '"' : '') +
            (poster ? ' poster="' + poster + '"' : '') +
            ' class="' +
            k +
            ' video-js" ' +
            ' webkit-playsinline="true" playsinline="true" controls preload="true" width="' +
            b +
            '" height="' +
            d +
            '" ' +
            'src="' +
            a +
            '" data-setup="{}">&nbsp;</video>'
          break
        // 插入音频
        case 'insertaudio':
        case 'audioimage':
        case 'audio':
          g =
            '&nbsp;<audio style="max-width:100%"  ' +
            (title ? 'title="' + title + '"' : '') +
            (e ? 'id="' + e + '"' : '') +
            '  url="' +
            a +
            '" urlapp="' +
            a +
            '" ' +
            '' +
            'width="' +
            b +
            '" height="' +
            d +
            '" style="max-width:100%;' +
            (b ? 'width:' + b + ';' : ';') +
            (d ? 'height:' + d : '') +
            '"' +
            'class="' +
            k +
            '" src="' +
            a +
            '" controls="controls" controlsList="nodownload" preload="true">&nbsp;</audio>&nbsp;'

          break
      }
      return g
    }
    function b(a, b) {
      p.each(a.getNodesByTagName(b ? 'img' : 'embed video'), function (a) {
        var c = a.getAttr('class')
        let g
        if (c && c.indexOf('edui-faked-video') !== -1) {
          g = d(
            b ? a.getAttr('_url') : a.getAttr('src'),
            a.getAttr('width'),
            a.getAttr('height'),
            null,
            a.getStyle('float') || 'center',
            c,
            b ? 'embed' : 'video'
          )
          a.parentNode.replaceChild(UE.uNode.createElement(g), a)
        }
        if (a.tagName === 'img') {
          g = d(
            a.getAttr('src'),
            a.getAttr('width'),
            a.getAttr('height'),
            null,
            a.getStyle('float') || '',
            c,
            'img'
          )
          a.parentNode.replaceChild(UE.uNode.createElement(g), a)
        }
        if (c && c.indexOf('edui-upload-video') !== -1) {
          g = d(
            b ? a.getAttr('_url') : a.getAttr('src'),
            a.getAttr('width'),
            a.getAttr('height'),
            null,
            a.getStyle('float') || '',
            c,
            b ? 'embed' : 'audio'
          )
          a.parentNode.replaceChild(UE.uNode.createElement(g), a)
        }
      })
    }
    function h(a) {
      p.each(a.querySelectorAll('video:not([data-orientation])'), function (d) {
        if (f.inDoc(d, a)) {
          d.addEventListener('loadedmetadata', function() {
            ad(d, a)
          })
        }
      })
    }
    function ad(v, d) {
      try {
        const w = v.videoWidth
        const h = v.videoHeight
        const ratio = w / h
        const maxHeight = d.body.offsetHeight - 50
        let type = ''
        if (ratio >= 1) {
          type = '1'
        } else {
          type = '0'
          v.setAttribute('height', maxHeight + 'px')
        }
        v.setAttribute('data-orientation', type)
      } catch (error) {
        console.log('error:', error)
      }
    }
    var c = this
    c.addOutputRule(function (a) {
      b(a, !0)
    })
    c.addInputRule(function (a) {
      b(a)
    })
    // 插入音频
    c.commands['music'] = {
      execCommand: function (cmd, audioObjs, type) {
        let g =
          '&nbsp;<audio ' +
          (audioObjs.aTitle ? 'title="' + audioObjs.aTitle + '"' : '') +
          (audioObjs.id ? 'id="' + audioObjs.id + '"' : '') +
          '  url="' +
          audioObjs.url +
          '" urlapp="' +
          audioObjs.url +
          '" ' +
          '' +
          'width="' +
          '300px' +
          '" height="' +
          '50px' +
          '" style="max-width:100%;' +
          '"' +
          ' class="" src="' +
          audioObjs.url +
          '" controls="controls" controlsList="nodownload" preload="true">&nbsp;</audio>&nbsp;<br>'
        this.execCommand('inserthtml', g, true)
        // 所有音频对象
        /* audioObjs = p.isArray(audioObjs) ? audioObjs : [audioObjs]
        var html = []
        var id = 'tmpAudie'
        var cl
        var i
        var vi
        var len = audioObjs.length
        for (i = 0; i < len; i++) {
          vi = audioObjs[i]
          cl = (type === 'upload' ? 'edui-upload-audio audio-js audiojs-default-skin' : 'edui-faked-audio')
          html.push(d(vi.url, vi.width || '300px', vi.height || '50px', id + i, null, cl, 'insertaudio', vi.aTitle))
        }
        this.execCommand('inserthtml', html.join(''), true)
        var rng = this.selection.getRange()
        for (i = 0; i < audioObjs.length; i++) {
          var img = this.document.getElementById('tmpAudie' + i)
          f.removeAttributes(img, 'id')
          rng.selectNode(img).select()
          c.execCommand('imagefloat', audioObjs[i].align)
        } */
      },
      queryCommandState: function () {
        var img = c.selection.getRange().getClosedNode()
        let flag =
          img &&
          (img.className === 'edui-faked-audio' ||
            img.className.indexOf('edui-upload-audio') !== -1)
        return flag ? 1 : 0
      }
    }
    c.commands.insertvideo = {
      execCommand: function (a, b, h) {
        b = p.isArray(b) ? b : [b]
        if (!0 !== c.fireEvent('beforeinsertvideo', b)) {
          var e = []
          a = 0
          e.push('<p style="text-align: center">')
          for (var g, k = b.length; a < k; a++) {
            g = b[a]
            var n =
              h === 'upload'
                ? 'edui-upload-video video-js vjs-default-skin'
                : 'edui-faked-video'
            e.push(
              d(
                g.url,
                g.width || '70%',
                g.height || 'auto',
                g.id,
                null,
                n,
                'video',
                g.content,
                g.picUrl
              )
            )
          }
          e.push('</p>')
          c.execCommand('inserthtml', e.join(''), !0)
          if (g.content && g.content !== '') {
            this.execCommand(
              'videocomment',
              g.id || g.videoID,
              g.content,
              false
            )
          }
          h = this.selection.getRange()
          a = 0
          for (k = b.length; a < k; a++) {
            e = this.document.getElementById('tmpVedio' + a)
            // f.removeAttributes(e, 'id')
            // h.selectNode(e).select()
            c.execCommand('imagefloat', b[a].align)
          }
          c.fireEvent('afterinsertvideo', b)
        }
      },
      queryCommandState: function () {
        var a = c.selection.getRange().getClosedNode()
        return (
          !a ||
          (a.className !== 'edui-faked-video' &&
          a.className.indexOf('edui-upload-video') === -1
            ? 0
            : 1)
        )
      }
    }
    c.addListener('contentchange', function () {
      h(c.document)
    })
  }

  // 右键菜单
  UE.plugins.contextmenu = function () {
    /* eslint-disable */
    var d = this
    d.setOpt('enableContextMenu', !0)
    if (!1 !== d.getOpt('enableContextMenu')) {
      var b = d.getLang('contextMenu'),
        c,
        a1 = d.options.contextMenu || [
          {
            label: b.selectall,
            cmdName: 'selectall'
          },
          {
            label: b.cleardoc,
            cmdName: 'cleardoc',
            exec: function () {
              confirm(b.confirmclear) && this.execCommand('cleardoc')
            }
          },
          // '-',
          {
            label: b.unlink,
            cmdName: 'unlink'
          },
          // '-',
          {
            group: b.paragraph,
            icon: 'justifyjustify',
            subMenu: [
              {
                label: b.justifyleft,
                cmdName: 'justify',
                value: 'left'
              },
              {
                label: b.justifyright,
                cmdName: 'justify',
                value: 'right'
              },
              {
                label: b.justifycenter,
                cmdName: 'justify',
                value: 'center'
              },
              {
                label: b.justifyjustify,
                cmdName: 'justify',
                value: 'justify'
              }
            ]
          },
          // '-',
          {
            label: '依文配图',
            cmdName: 'onlinephotos',
            icon: 'onlinephotos'
          },
          {
            label: b.insertparagraphbefore,
            cmdName: 'insertparagraph',
            value: true
          },
          {
            label: b.insertparagraphafter,
            cmdName: 'insertparagraph'
          },
          {
            label: b['copy'],
            cmdName: 'copy'
          },
          {
            label: b['paste'],
            cmdName: 'paste'
          },
          {
            label: b['pasteplaintext'],
            cmdName: 'pasteplaintext'
          },
          {
            label: '剪切(Ctrl + x)',
            cmdName: 'shears',
            icon: 'shears'
          },
          {
            group: b.aligntable,
            icon: 'aligntable',
            subMenu: [
              {
                cmdName: 'tablealignment',
                className: 'left',
                label: b.tableleft,
                value: 'left'
              },
              {
                cmdName: 'tablealignment',
                className: 'center',
                label: b.tablecenter,
                value: 'center'
              },
              {
                cmdName: 'tablealignment',
                className: 'right',
                label: b.tableright,
                value: 'right'
              }
            ]
          }
        ]
      if (customConfig.deletetable) {
        a1.push({
          label: '删除(backspace/delete)',
          cmdName: 'deletes',
          icon: 'deletes'
        })
      }
      if (customConfig.commentable) {
        a1.push({
          label: '添加批注',
          cmdName: 'comments',
          icon: 'comments'
        })
      }

      if (
        [
          'origin',
          'audit',
          'dep',
          'paper',
          'journal',
          'app',
          'web',
          'my',
          'wx',
          'weibo',
          'others',
          'tv'
        ].includes(service.getService())
      ) {
        let aiSubMenu = window.sessionStorage.getItem('yqMfAiSubMenu'),
          aiSubMenus = []
        if (aiSubMenu && JSON.parse(aiSubMenu)) {
          aiSubMenus = JSON.parse(aiSubMenu)
        }
        a1.unshift({
          cmdName: 'mfai',
          group: 'mfai',
          icon: 'mfai',
          subMenu: aiSubMenus.map((item) => {
            return {
              ...item,
              cmdName: 'mfai',
              mfIcon: item.icon
            }
          })
        })
      }
      if (!customConfig.onlinephotosable) {
        a1 = a1.filter((item) => item.cmdName !== 'onlinephotos')
      }
      if (a1.length) {
        let yqMagicCubeCreatorAuth = window.sessionStorage.getItem(
          'yqMagicCubeCreator'
        )
          ? true
          : false
        // console.log(yqMagicCubeCreatorAuth);
        var g = UE.ui.uiUtils
        d.addListener('contextmenu', function (h, e) {
          var node = d.selection.getRange()
          var a = JSON.parse(JSON.stringify(a1)).map((item) => item)
          if (node.collapsed) {
            a = a.filter(
              (item) =>
                item.cmdName !== 'onlinephotos' &&
                item.cmdName !== 'comments' &&
                item.group !== 'mfai'
            )
          } else if (!yqMagicCubeCreatorAuth) {
            a = a.filter((item) => item.group !== 'mfai')
          }
          h = g.getViewportOffsetByEvent(e)

          d.fireEvent('beforeselectionchange')
          c && c.destroy()
          // a是右键的列表
          // k是a[0],a[1],a[2]...
          for (var l = 0, k, n = []; (k = a[l]); l++) {
            var m
            ;(function (a) {
              if (a == '-') (m = n[n.length - 1]) && m !== '-' && n.push('-')
              else if (a.hasOwnProperty('group')) {
                for (var c = 0, e, k = []; (e = a.subMenu[c]); c++) {
                  ;(function (a) {
                    a == '-'
                      ? (m = k[k.length - 1]) && m !== '-'
                        ? k.push('-')
                        : k.splice(k.length - 1)
                      : (d.commands[a.cmdName] ||
                          UE.commands[a.cmdName] ||
                          a.query) &&
                        (a.query ? a.query() : d.queryCommandState(a.cmdName)) >
                          -1 &&
                        k.push({
                          label:
                            a.label ||
                            d.getLang(
                              'contextMenu.' + a.cmdName + (a.value || '')
                            ) ||
                            '',
                          className:
                            'edui-for-' +
                            a.cmdName +
                            (a.className
                              ? ' edui-for-' + a.cmdName + '-' + a.className
                              : ''),
                          icon: a.mfIcon || a.icon,
                          onclick: a.exec
                            ? function () {
                                a.exec.call(d)
                              }
                            : function () {
                                d.execCommand(a.cmdName, a.value)
                              }
                        })
                  })(e)
                }
                k.length &&
                  n.push({
                    label: (function () {
                      switch (a.icon) {
                        case 'table':
                          return d.getLang('contextMenu.table')
                        case 'justifyjustify':
                          return d.getLang('contextMenu.paragraph')
                        case 'aligntd':
                          return d.getLang('contextMenu.aligntd')
                        case 'aligntable':
                          return d.getLang('contextMenu.aligntable')
                        case 'tablesort':
                          return b.tablesort
                        case 'borderBack':
                          return b.borderbk
                        case 'mfai':
                          return yqMagicCubeCreatorName
                        default:
                          return ''
                      }
                    })(),
                    className: 'edui-for-' + a.icon,
                    subMenu: {
                      items: k,
                      editor: d
                    }
                  })
              } else {
                ;(d.commands[a.cmdName] || UE.commands[a.cmdName] || a.query) &&
                  (a.query ? a.query.call(d) : d.queryCommandState(a.cmdName)) >
                    -1 &&
                  n.push({
                    label: a.label || d.getLang('contextMenu.' + a.cmdName),
                    className:
                      'edui-for-' +
                      (a.icon ? a.icon : a.cmdName + (a.value || '')),
                    onclick: a.exec
                      ? function () {
                          a.exec.call(d)
                        }
                      : function () {
                          d.execCommand(a.cmdName, a.value)
                        }
                  })
              }
            })(k)
          }
          if (e.target.nodeName === 'VIDEO') {
            // 清空数组 n
            n.length = 0
            // 插入 deletevideo
            n.push({
              label: b['deletevideo'],
              className: 'edui-for-delete',
              onclick: function () {
                d.execCommand('deletevideo', e.target)
              }
            })
            // 插入 settitlepic
            n.push({
              label: b['settitlepic'],
              className: 'edui-for-pic',
              onclick: function () {
                d.execCommand('settitlepic', e.target)
              }
            })
            // 插入 setvideocomment  必须全小写
            n.push({
              label: b['setvideocomment'],
              className: 'edui-for-comment',
              onclick: function () {
                d.execCommand('setvideocomment', e.target)
              }
            })
          }
          if (e.target.nodeName === 'AUDIO') {
            n.splice(2, 0, {
              label: b['deletemusic'],
              className: 'edui-for-delete',
              onclick: function () {
                d.execCommand('deletemusic', e.target)
              }
            })
          }
          // 如果是图片，则右键显示下载按钮
          if (e.target.nodeName === 'IMG') {
            n.splice(11, 0, {
              label: b['downloadimage'],
              className: 'edui-for-mergedown',
              onclick: function () {
                d.fireEvent('downloadimage', e.target)
              }
            })
          }
          n[n.length - 1] == '-' && n.pop()
          c = new UE.ui.Menu({
            items: n,
            className: 'edui-contextmenu',
            editor: d
          })
          c.render()
          c.showAt(h)
          d.fireEvent('aftershowcontextmenu', c)
          f.preventDefault(e)
          let u = window.UE.browser
          if (u && u.ie) {
            try {
              var q = d.selection.getNative().createRange()
            } catch (t) {
              return
            }
            q.item &&
              new D.Range(d.document).selectNode(q.item(0)).select(!0, !0)
          }
        })
        d.addListener('aftershowcontextmenu', function (a, b) {
          if (d.zeroclipboard) {
            a = b.items
            for (var c in a)
              a[c].className == 'edui-for-copy' &&
                d.zeroclipboard.clip(a[c].getDom())
          }
        })
      }
    }
  }
}

// 清除格式
function autoTypeSet(UE) {
  var utils = UE.utils

  var domUtils = UE.dom.domUtils
  var dtd = UE.dom.dtd
  // 可以去掉的标签
  var removeTagNames = utils.extend({ div: 1 }, dtd.$removeEmpty)
  UE.plugins['autotypeset'] = function () {
    let nationalFontTheme = '' // 民族文主题
    if (this.options && this.options.customFontSetting && this.options.customFontSetting.type === 'national' && this.options.customFontSetting.fontItem && this.options.customFontSetting.fontItem.name) {
      nationalFontTheme = this.options.customFontSetting.fontItem.val
    }
    this.setOpt({
      autotypeset: {
        //  keepBlankBetweenP:true,         //保持段落间距离
        mergeEmptyline: true, // 合并空行
        removeClass: true, // 去掉冗余的class
        removeEmptyline: false, // 去掉空行
        textAlign: 'left', // 段落的排版方式，可以是 left,right,center,justify 去掉这个属性表示不执行排版
        imageBlockLine: 'center', // 图片的浮动方式，独占一行剧中,左右浮动，默认: center,left,right,none 去掉这个属性表示不执行排版
        imageTitle: true,
        pasteFilter: false, // 根据规则过滤没事粘贴进来的内容
        clearLayout: false, // 清除版式
        clearFontSize: false, // 去掉所有的内嵌字号，使用编辑器默认的字号
        clearFontFamily: false, // 去掉所有的内嵌字体，使用编辑器默认的字体
        clearTable: false, // 去掉所有的表格标签
        removeEmptyNode: false, // 去掉空节点
        keepSpaceBetweenPra: false, // 保持段落间距
        indent: false, // 行首缩进
        indentValue: '2em', // 行首缩进的大小
        bdc2sb: false, // 符号  全转半
        tobdc: false, // 符号 半转全
        bdc2sb_num: false, // 数字 全转半
        tobdc_num: false, // 数字 半转全
        word_toall: false, // 字母全转半
        word_tohalf: false, // 字母半转全
        p2br: false, // 换段转换行
        br2p: false, // 换行转换段
        clearAllHtag: false // 去掉所有的 h 标签
      }
    })

    let me = this
    let opt = me.options.autotypeset

    let remainClass = {
      selectTdClass: 1,
      pagebreak: 1,
      anchorclass: 1
    }
    let remainTag = { li: 1 }
    let tags = {
      section: 1,
      div: 1,
      p: 1,
      // trace:2183 这些也认为是行
      blockquote: 1,
      center: 1,
      h1: 1,
      h2: 1,
      h3: 1,
      h4: 1,
      h5: 1,
      h6: 1,
      span: 1
    }
    let highlightCont

    // 升级了版本，但配置项目里没有autotypeset
    if (!opt) {
      return
    }

    readLocalOpts()
    function isLine(node, notEmpty) {
      if (!node || node.nodeType === 3) {
        return 0
      }
      if (domUtils.isBr(node)) {
        return 1
      }
      if (node && node.parentNode && tags[node.tagName.toLowerCase()]) {
        if (
          (highlightCont && highlightCont.contains(node)) ||
          node.getAttribute('pagebreak')
        ) {
          return 0
        }

        return notEmpty
          ? !domUtils.isEmptyBlock(node)
          : domUtils.isEmptyBlock(
              node,
              new RegExp('[\\s' + domUtils.fillChar + ']', 'g')
            )
      }
    }

    function removeNotAttributeSpan(node) {
      if (!node.style.cssText) {
        domUtils.removeAttributes(node, ['style'])
        if (
          node.tagName.toLowerCase() === 'span' &&
          domUtils.hasNoAttributes(node)
        ) {
          domUtils.remove(node, true)
        }
      }
    }
    /*
     * 点击自动排版的小按钮或者点击进去以后点击“执行”按钮此处代码被调用----------
     */
    function autotype(type, html) {
      let me = this
      let cont // this是指UE.Editor,
      if (html) {
        if (!opt.pasteFilter) {
          return
        }
        cont = me.document.createElement('div')
        cont.innerHTML = html.html
      } else {
        cont = me.document.body // me是指UE.Editor
      }
      // 清除版式
      try {
        if (opt.clearLayout) {
          var _html = cont.innerHTML;
          // 移除换行符、回车符和制表符
          _html = _html.replace(/[\n\r\t]/g, '')
          // 移除指定的HTML标签（如html、head、body等结构标签）
          .replace(/<[\s]*[\/]?(html|head|body|title|meta|article|aside|header|footer|ol|ul|pre|blockquote|nav|main|details|summary|dialog|menuitem|datalist|template|math)(\s[^>]+)*>/gim, '')
          // 将指定标签（如section、div等）替换为p标签
          .replace(/(<[\s]*[\/]?)(section|figure|h1|h2|h3|h4|h5|h6|li|code|table|thead|tbody|tr|th|menu|ckesignature|div|time|mark|abbr|address|optgroup|fieldset|legend|label|output|progress|meter)(\s[^>]+)*>/gim, '$1p>')
          // 除指定的HTML标签（如figcaption、strong等标签）
          .replace(/(<[\s]*[\/]?)(figcaption|strong|i|button|text|sub|sup|td|font|span|small|em|b|u|s|strike|ins|del|kbd|var|samp|cite|dfn|wbr|bdi|bdo|ruby|rt|rp|data)(\s[^>]+)*>/gim, '')
          // 将br标签保留，但移除其属性
          .replace(/<([\s]*[\/]?)(br)(\s[^>]+)*>/gim, '<$2>')
          // 处理嵌套的p标签，将连续的开始p标签替换为单个p标签
          .replace(/<p[^>]*>(\s*<p[^>]*>)+/gim, '<p>')
          // 处理嵌套的p标签，将连续的结束p标签替换为单个结束p标签
          .replace(/<\/p>\s*(<\/p>)+/gim, '</p>')
          // 移除完全空的p标签
          .replace(/<p[^>]*><\/p>/gim, '')
          // 移除只包含空白字符的p标签
          .replace(/<p[^>]*>\s*<\/p>/gim, '');
          cont.innerHTML = _html;
        }
      } catch (error) {
        console.log("error:", error)
      }

      /* 清除格式-清除空格（客户特殊需求）。 */
      if (opt.removeClass) {
        let strHtml = $(cont)
          .html()
          .replace(/(&nbsp;)+/g, '')
        strHtml = strHtml.replace(/\>(\s|　)+/g, '>')
        $(cont).html(strHtml)
      }

      // 去掉所有的 h 标签
      if (opt.clearAllHtag) {
        const hTagRegex = /<\/?h[1-6](.*?)>/gi
        cont.innerHTML = cont.innerHTML.replace(hTagRegex, (match) => {
          // 如果是开始标签
          if (match.startsWith('<h')) {
            return '<p' + match.substring(3, match.length - 1) + '>'
          }
          // 如果是结束标签
          else if (match.startsWith('</h')) {
            return '</p>'
          }
          // 其他情况（理论上不会发生）
          return match
        })
      }

      try {
        if (opt.br2p) {
          cont.innerHTML = cont.innerHTML
            .replace(/<[\s]*[\/]*br[^>]*>/gim, '<br/>')
            .replace(/<[\s]*\/[\s]*p>/gim, '</p>')
            .replace(/<br\/>[\s]*<\/p>[\s]*/gim, '</p>')
            .replace(/<br\/>/gim, '</p><p>')
        } else if (opt.p2br) {
          cont.innerHTML = cont.innerHTML
            .replace(/<[\s]*[\/]*br[^>]*>/gim, '<br/>')
            .replace(
              /(<br\/>)*<[\s]*[\/]*p[\s]*>[\s]*<[\s]*p[^>]*>/gim,
              '<br/>'
            )
        }
      } catch (e) {
        console.error('brpError:', e)
      }

      // 获取文章内容标签节点
      let nodes = domUtils.getElementsByTagName(cont, '*')

      // 行首缩进，段落方向，段间距，段内间距
      for (var i = 0, ci; i < nodes.length; i++) {
        ci = nodes[i]
        // 清除版式
        if (opt.clearLayout) {
          var $ci = $(ci)
          var ciTagName = ci.tagName.toLowerCase()
          if (
            ciTagName === 'iframe' ||
            ciTagName === 'svg' ||
            ciTagName === 'g' ||
            ciTagName === 'path' ||
            ciTagName === 'canvas' ||
            ciTagName === 'icon' ||
            ciTagName === 'input' ||
            ciTagName === 'textarea' ||
            ciTagName === 'select' ||
            ciTagName === 'option' ||
            ciTagName === 'hr' ||
            ciTagName === 'link' ||
            ciTagName === 'script' ||
            ciTagName === 'noscript' ||
            ciTagName === 'style'
          ) {
            ci.remove()
          } else {
            if (ciTagName === 'img') {
              $ci.removeAttr('alt')
              $ci.removeAttr('title')
            }
            $ci.removeAttr('style')
            $ci.removeAttr('class')
            $ci.removeAttr('width')
            $ci.removeAttr('height')
          }
        }
        if (
          ci.tagName.toLowerCase() === 'p' &&
          ci.attributes &&
          ci.attributes.getNamedItem('founder-image-comment-id')
        ) {
          // 图说p标签不处理
          continue
        } else if (
          ci.tagName.toLowerCase() === 'hr' &&
          ci.classList &&
          ci.classList.contains('ueditor_page_break_tag')
        ) {
          // 网站分页标签不处理
          continue
        } else if (
          ci.tagName.toLowerCase() === 'p' &&
          ci.attributes &&
          ci.attributes.getNamedItem('yq_contentFiles')
        ) {
          // 稿件内附件不清理
          continue
        }
        /*
         * 清除样式,清除每个标签的样式-------------
         * 清楚样式要放在最前面，避免排版时，设置的别的样式在清除格式时被清掉。
         */
        /*
         * 表格标签
         */
        if (opt.clearTable) {
          let tableRemoveTag = 'table,tbody,thead,th,tr,td'
          if (tableRemoveTag.indexOf(ci.tagName.toLowerCase()) > -1) {
            tableRemoveTag.split(',').forEach((tag) => {
              $(ci)
                .find(tag)
                .each(function (i, t) {
                  $(t).replaceWith($.trim($(t).html()))
                })
            })
          }
          if (tableRemoveTag.split(',').includes(ci.tagName.toLowerCase())) {
            $(ci).replaceWith($.trim($(ci).html()))
          }
        }
        if (opt.removeClass) {
          // 处理blockquote
          if (ci.tagName.toLowerCase() === 'blockquote') {
            $(ci)
              .find('p')
              .each(function () {
                var _this = $(this)
                _this.attr('style', '')
              })
            $(ci)
              .find('span')
              .each(function () {
                var _this = $(this)
                _this.replaceWith($.trim(_this.html()))
              })
            $(ci).replaceWith($.trim($(ci).html()))
          }
          // h2
          if (ci.tagName.toLowerCase() === 'h2') {
            $(ci).attr('style', '')
          }

          let removeTags =
            'h1,h2,h3,h4,h5,h6,b,big,code,del,section,dfn,em,font,i,ins,kbd,q,samp,small,span,strike,strong,tt,u,var,div,p'
          let removeFormatAttributes =
            'class,style,lang,width,height,align,hspace,valign,dir,data-pm-slice,data-source'
          if (removeTags.indexOf(ci.tagName.toLowerCase()) > 0) {
            // 清除样式
            domUtils.removeAttributes(ci, removeFormatAttributes.split(','))
            // $(ci).replaceWith($.trim($(ci).html()))

            removeTags.split(',').forEach((tag) => {
              $(ci)
                .find(tag)
                .each(function (i, t) {
                  if (
                    !(
                      t.tagName.toLowerCase() === 'p' &&
                      t.attributes &&
                      t.attributes.getNamedItem('founder-image-comment-id')
                    )
                  ) {
                    domUtils.removeAttributes(
                      t,
                      removeFormatAttributes.split(',')
                    )
                  }

                  // BUG #289392 如果包含div与p标签时，在自动排版选中清除格式时，会将编辑器中div标签内的p标签或者p标签内的div标签清除掉，导致丢失段落格式
                  // BUG #299122 如果包含section标签时，在自动排版选中清除格式时，会将编辑器中section标签清除掉，导致section中图片浮动-居中失效
                  if (t.tagName !== 'DIV' && t.tagName !== 'P')
                    $(t).replaceWith($.trim($(t).html()))
                })
            })

            // BUG #293613 加下面三行代码会导致调用isLine(ci, true)函数时node.parentNode返回null值，导致一系列问题
            // 处理空格 删除中文间空格 保留英文间空格 @"\p{P}
            // var strHtml = $(ci).html()
            // strHtml = strHtml.replace(/(&nbsp;)+(?=[\u4e00-\u9fa5]|[0-9]|[，,。.?？:：;；''‘’!！""“”—……、 ])/g, '')
            // $(ci).html(strHtml.replace(/[ ]+(?=[\u4e00-\u9fa5]|[0-9]|[，,。.?？:：;；''‘’!！""“”—……、 ])/g, ''))

            // 对p内br的处理
            // $(ci)
            //   .find('br')
            //   .each(function () {
            //     var _this = $(this)
            //     _this.prev().wrap('<br>')
            //     _this.next().wrap('<br>')
            //     _this.remove()
            //   })

            // 对p内strong的处理
            $(ci)
              .find('strong')
              .each(function () {
                var _this = $(this)
                _this.replaceWith($.trim(_this.html()))
              })

            // 对p内span的处理
            $(ci)
              .find('span')
              .each(function () {
                var _this = $(this)
                _this.replaceWith($.trim(_this.html()))
              })

            // 处理iframe
            $(ci)
              .find('iframe')
              .each(function () {
                var _this = $(this)
                _this.attr('style', 'max-width:100%;height:auto;')
                _this.attr('width', '').attr('height', '')
              })

            // 对p内img的处理
            $(ci)
              .find('img')
              .each(function () {
                var _this = $(this)
                _this.attr('style', 'max-width:100%;height:auto;')
              })

            // video
            $(ci)
              .find('video')
              .each(function () {
                var _this = $(this)
                _this.attr('style', 'max-width:100%;height:auto;')
              })

            // audio
            $(ci)
              .find('audio')
              .each(function () {
                var _this = $(this)
                // _this.attr('style', 'max-width:100%;height:auto;') 音频标签高度设为auto会不显示，固清除格式时设置为默认值
                _this.attr('style', 'width:300px;height:54px;')
              })

            // 对生成新p标签的处理
            $(ci)
              .find('p')
              .each(function () {
                var _this = $(this)
                if (!_this.attr('founder-image-comment-id')) {
                  // _this.attr('style', '')
                  _this.removeAttr('style')
                  if (opt.indent) {
                    if (
                      _this.children() &&
                      _this.children().eq(0).prop('tagName') !== 'IMG' &&
                      _this.children().eq(0).prop('tagName') !== 'VIDEO'
                    ) {
                      _this.css('text-indent', opt.indentValue)
                    }
                  }
                  if (opt.keepSpaceBetweenPra) {
                    _this.css('margin-bottom', '15px')
                  }
                  if (opt.imageBlockLine) {
                    if (
                      _this.children() &&
                      (_this.children().eq(0).prop('tagName') === 'IMG' ||
                        _this.children().eq(0).prop('tagName') === 'VIDEO')
                    ) {
                      _this.css('text-align', opt.imageBlockLine)
                    }
                  }
                }
              })

            if (ci.tagName === 'DIV') {
              let indent = '',
                keepSpaceBetweenPra = '',
                imageBlockLine = ''
              if (opt.indent) {
                if (
                  $(ci).children() &&
                  $(ci).children().eq(0).prop('tagName') !== 'IMG' &&
                  $(ci).children().eq(0).prop('tagName') !== 'VIDEO'
                ) {
                  indent = `text-indent: ${opt.indentValue};`
                }
              }
              if (opt.keepSpaceBetweenPra) {
                keepSpaceBetweenPra = `margin-bottom: 15px;`
              }
              if (opt.imageBlockLine) {
                if (
                  $(ci).children() &&
                  ($(ci).children().eq(0).prop('tagName') === 'IMG' ||
                    $(ci).children().eq(0).prop('tagName') === 'VIDEO')
                ) {
                  imageBlockLine = `text-align: ${opt.imageBlockLine};`
                } else if (opt.textAlign) {
                  imageBlockLine = `text-align: ${opt.textAlign};`
                }
              }

              let ciHtml = `<p style="${indent}${keepSpaceBetweenPra}${imageBlockLine}">${$.trim(
                $(ci).html()
              )}</p>`
              $(ci).replaceWith(ciHtml)
            }

            // 如果首行缩进同时也被选中，则让段落首行缩进2字符
            if (opt.indent) {
              // 增加超链接情况的判断
              var ciChildren = $(ci).children();
              if (ciChildren && ciChildren.eq(0).prop('tagName') === 'A') ciChildren = ciChildren.eq(0).children();
              if (ciChildren && $(ci).prop('tagName') !== 'A') {
                var ciChildrenTagName = ciChildren.eq(0).prop('tagName');
                if (ciChildrenTagName !== 'IMG' && ciChildrenTagName !== 'VIDEO') {
                  ci.style['text-indent'] = opt.indentValue
                }
              }
            }
            // 段落行间距
            if (opt.keepSpaceBetweenPra) {
              ci.style['marginBottom'] = '15px'
            }
            // 图片居中
            if (opt.imageBlockLine) {
              // 增加超链接情况的判断
              var ciChildren = $(ci).children();
              if (ciChildren && ciChildren.eq(0).prop('tagName') === 'A') ciChildren = ciChildren.eq(0).children();
              if (ciChildren && $(ci).prop('tagName') !== 'A') {
                var ciChildrenTagName = ciChildren.eq(0).prop('tagName');
                if (ciChildrenTagName === 'IMG' || ciChildrenTagName === 'VIDEO') {
                  $(ci).css('text-align', opt.imageBlockLine)
                }
              }
            }
          }
          /* if(ci.tagName.toLowerCase() === 'span'){
           $(ci).replaceWith($.trim($(ci).html()));
           } */

          // 处理p中嵌套两层span
          if (ci.tagName.toLowerCase() === 'p') {
            $(ci)
              .find('span')
              .each(function () {
                var _this = $(this)
                _this.replaceWith($.trim(_this.html()))
              })
          }
          // 需求 #794630 【云雀插队紧急需求】-【编辑器】一键排版的粘贴过滤执行后，保留超链接(有href)不进行过滤
          if (
            (ci.tagName.toLowerCase() === 'a' && !ci.href) ||
            ci.tagName.toLowerCase() === 'strong' ||
            ci.tagName.toLowerCase() === 'section'
          ) {
            $(ci).replaceWith($(ci).html())
          }
          if (ci.tagName.toLowerCase() === 'iframe') {
            domUtils.removeAttributes(ci, ['src'])
            domUtils.remove(ci)
          }
        }

        // font-size
        if (opt.clearFontSize && ci.style.fontSize) {
          domUtils.removeStyle(ci, 'font-size')
          removeNotAttributeSpan(ci)
        }
        // font-family
        if (opt.clearFontFamily && ci.style.fontFamily) {
          domUtils.removeStyle(ci, 'font-family')
          removeNotAttributeSpan(ci)
        }

        if (isLine(ci)) {
          // 合并空行
          if (opt.mergeEmptyline) {
            var next = ci.nextSibling
            var tmpNode
            var isBr = domUtils.isBr(ci)
            while (isLine(next)) {
              tmpNode = next
              next = tmpNode.nextSibling
              if (isBr && (!next || (next && !domUtils.isBr(next)))) {
                break
              }
              domUtils.remove(tmpNode)
            }
          }
          // 去掉空行，保留占位的空行
          if (
            opt.removeEmptyline &&
            domUtils.inDoc(ci, cont) &&
            !remainTag[ci.parentNode.tagName.toLowerCase()]
          ) {
            if (domUtils.isBr(ci)) {
              next = ci.nextSibling
              if (next && !domUtils.isBr(next)) {
                continue
              }
            }
            domUtils.remove(ci)
            continue
          }
        }
        if (isLine(ci, true) && ci.tagName !== 'SPAN') {
          // BUG #293613 加下面三行代码会导致调用isLine(ci, true)函数时node.parentNode返回null值，导致一系列问题
          // var re = new RegExp('^((\&nbsp\;)+)*', 'g')
          // ci.innerHTML = ci.innerHTML.replace(re, '')
          // ci.innerHTML = ci.innerHTML.replace(/(^\s*)/g, '')

          if (opt.indent) {
            // 增加超链接情况的判断
            var ciChildren = $(ci).children();
            if (ciChildren && ciChildren.eq(0).prop('tagName') === 'A') ciChildren = ciChildren.eq(0).children();
            if (ciChildren && $(ci).prop('tagName') !== 'A') {
              var ciChildrenTagName = ciChildren.eq(0).prop('tagName');
              if (ciChildrenTagName !== 'IMG' && ciChildrenTagName !== 'VIDEO') {
                ci.style.textIndent = opt.indentValue
              }
            }
          }
          if (opt.textAlign && ci.tagName !== 'BR') {
            ci.style.textAlign = opt.textAlign
          }
          // 图片居中
          if (opt.imageBlockLine) {
            // 增加超链接情况的判断
            var ciChildren = $(ci).children();
            if (ciChildren && ciChildren.eq(0).prop('tagName') === 'A') ciChildren = ciChildren.eq(0).children();
            if (ciChildren && $(ci).prop('tagName') !== 'A') {
              var ciChildrenTagName = ciChildren.eq(0).prop('tagName');
              if (ciChildrenTagName === 'IMG' || ciChildrenTagName === 'VIDEO') {
                $(ci).css('text-align', opt.imageBlockLine)
              }
            }
          }
          // if(opt.lineHeight) ci.style.lineHeight = opt.lineHeight + 'cm';
        }

        if (opt.keepLine && ci.tagName.toLowerCase() === 'p') {
          ci.style['marginBottom'] = '15px'
        }
        // 去除图片标题(image标签title属性)
        if (opt.imageTitle) {
          $(ci)
            .find('img')
            .each(function () {
              var _this = $(this)
              _this.attr('title', '')
            })
        }
        // 首行缩进
        if (opt.indent) {
          if (
            ci.tagName.toLowerCase() === 'p' &&
            !(
              ci.attributes &&
              ci.attributes.getNamedItem('founder-image-comment-id')
            )
          ) {
            // 增加超链接情况的判断
            var ciChildren = $(ci).children();
            if (ciChildren && ciChildren.eq(0).prop('tagName') === 'A') ciChildren = ciChildren.eq(0).children();
            if (ciChildren && $(ci).prop('tagName') !== 'A') {
              var ciChildrenTagName = ciChildren.eq(0).prop('tagName');
              if (ciChildrenTagName !== 'IMG' && ciChildrenTagName !== 'VIDEO') {
                ci.style['text-indent'] = '2em'
              }
            }
          }
        }
        // 保留行间距
        if (opt.keepSpaceBetweenPra) {
          if (ci.tagName.toLowerCase() === 'p') {
            ci.style['marginBottom'] = '15px'
          }
        }
        if (
          opt.removeClass &&
          ci.className &&
          ci.className.toLowerCase &&
          !remainClass[ci.className.toLowerCase()]
        ) {
          if (highlightCont && highlightCont.contains(ci)) {
            continue
          }
          if (ci.className.indexOf('edui-faked-') === -1) {
            domUtils.removeAttributes(ci, ['class'])
          }
        }

        // 表情不处理
        if (
          opt.imageBlockLine &&
          ci.tagName.toLowerCase() === 'img' &&
          !ci.getAttribute('emotion')
        ) {
          if (html) {
            var img = ci
            let tmpNode
            switch (opt.imageBlockLine) {
              case 'left':
              case 'right':
              case 'none':
                var pN = img.parentNode
                let pre
                let next
                if (pN && pN.tagName) {
                  while (
                    pN &&
                    domUtils.getChildCount(pN, function (node) {
                      return (
                        !domUtils.isBr(node) && !domUtils.isWhitespace(node)
                      )
                    }) === 1 &&
                    (dtd.$inline[pN.tagName] || pN.tagName === 'A')
                  ) {
                    tmpNode = pN
                    pN = pN.parentNode
                  }
                  if (
                    tmpNode &&
                    tmpNode.tagName &&
                    tmpNode.tagName === 'P' &&
                    domUtils.getStyle(tmpNode, 'text-align') === 'center'
                  ) {
                    if (
                      tmpNode &&
                      !domUtils.isBody(tmpNode) &&
                      domUtils.getChildCount(tmpNode, function (node) {
                        return (
                          !domUtils.isBr(node) && !domUtils.isWhitespace(node)
                        )
                      }) === 1
                    ) {
                      pre = tmpNode.previousSibling
                      next = tmpNode.nextSibling
                      if (
                        pre &&
                        next &&
                        pre.nodeType === 1 &&
                        next.nodeType === 1 &&
                        pre.tagName === next.tagName &&
                        domUtils.isBlockElm(pre)
                      ) {
                        pre.appendChild(tmpNode.firstChild)
                        while (next.firstChild) {
                          pre.appendChild(next.firstChild)
                        }
                        domUtils.remove(tmpNode)
                        domUtils.remove(next)
                      } else {
                        domUtils.setStyle(tmpNode, 'text-align', '')
                      }
                    }
                  }
                }
                domUtils.setStyle(img, 'float', opt.imageBlockLine)
                break
              case 'center':
                if (me.queryCommandValue('imagefloat') !== 'center') {
                  pN = img.parentNode
                  domUtils.setStyle(img, 'float', 'none')
                  tmpNode = img
                  while (
                    pN &&
                    domUtils.getChildCount(pN, function (node) {
                      return (
                        !domUtils.isBr(node) && !domUtils.isWhitespace(node)
                      )
                    }) === 1 &&
                    (dtd.$inline[pN.tagName] || pN.tagName === 'A')
                  ) {
                    tmpNode = pN
                    pN = pN.parentNode
                  }
                  var pNode = me.document.createElement('p')
                  domUtils.setAttributes(pNode, {
                    style: 'text-align:center'
                  })
                  if (tmpNode.parentNode) {
                    // 检查父节点是否已经是P标签，避免嵌套
                    if (tmpNode.parentNode.tagName !== 'P') {
                      tmpNode.parentNode.insertBefore(pNode, tmpNode)
                      pNode.appendChild(tmpNode)
                      domUtils.setStyle(tmpNode, 'float', '')
                    }
                  } else {
                    pNode.appendChild(tmpNode)
                    tmpNode.innerHTML = pNode.outerHTML
                    domUtils.setStyle(img, 'float', '')
                  }
                }
            }
          } else {
            /* var range = me.selectiodomUtils.getn.getRange();
             range.selectNode(ci).select();
             me.execCommand('imagefloat', opt.imageBlockLine); */
          }
        }

        // 去掉冗余的标签-------
        // 上面处理的有关图片浮动和文章对齐的问题 其实没有兼容Section、Span等非容器标签 还是会被这里删除导致第一次粘贴过滤和第二三次不一样
        // 试图把去掉荣誉标签放到最上面处理 反而出现了 内网图片地址被清理掉的情况 回头优化下
        if (opt.removeEmptyNode) {
          if (
            removeTagNames[ci.tagName.toLowerCase()] &&
            domUtils.hasNoAttributes(ci) &&
            domUtils.isEmptyBlock(ci)
          ) {
            domUtils.remove(ci)
          }
        }
      }

      if (opt.tobdc) {
        var root = UE.htmlparser(cont.innerHTML)
        root.traversal(function (node) {
          if (node.type === 'text') {
            node.data = ToDBC(node.data)
          }
        })

        function replaceQuotes(quotesHtml) {
          return quotesHtml.replace(
            />([^<]*)</g,
            function (match, textContent) {
              // 将文字部分的英文双引号替换成中文前后双引号
              const replacedText = textContent.replace(/"([^"]*)"/gims, '“$1”')
              // 返回替换后的内容
              return '>' + replacedText + '<'
            }
          )
        }
        let tobdcHtml = root.toHtml()
        cont.innerHTML = replaceQuotes(tobdcHtml)
      }
      if (opt.bdc2sb) {
        let root = UE.htmlparser(cont.innerHTML)
        root.traversal(function (node) {
          if (node.type === 'text') {
            node.data = DBC2SB(node.data)
          }
        })
        // 双引号特殊处理
        let bdc2sbHtml = root.toHtml()
        cont.innerHTML = bdc2sbHtml.replace(/“/g, '"').replace(/”/g, '"')
      }

      // 20160714---------------
      if (opt.word_tohalf) {
        let root = UE.htmlparser(cont.innerHTML)
        root.traversal(function (node) {
          if (node.type === 'text') {
            node.data = WORD_TOHALF(node.data)
          }
        })
        cont.innerHTML = root.toHtml()
      }

      if (opt.word_toall) {
        let root = UE.htmlparser(cont.innerHTML)
        root.traversal(function (node) {
          if (node.type === 'text') {
            node.data = WORD_TOALL(node.data)
          }
        })
        cont.innerHTML = root.toHtml()
      }

      if (opt.tobdc_num) {
        let root = UE.htmlparser(cont.innerHTML)
        root.traversal(function (node) {
          if (node.type === 'text') {
            node.data = ToDBCNum(node.data)
          }
        })
        cont.innerHTML = root.toHtml()
      }
      if (opt.bdc2sb_num) {
        let root = UE.htmlparser(cont.innerHTML)
        root.traversal(function (node) {
          if (node.type === 'text') {
            node.data = DBC2SBNum(node.data)
          }
        })
        cont.innerHTML = root.toHtml()
      }
      // 去除超链接 和 strong字体加粗----------------
      nodes = domUtils.getElementsByTagName(cont, '*')
      for (let i = 0, ci; i < nodes.length; i++) {
        ci = nodes[i]
        // 需求 #794630 【云雀插队紧急需求】-【编辑器】一键排版的粘贴过滤执行后，保留超链接(有href)不进行过滤
        if (ci.tagName.toLowerCase() === 'a' && !ci.href && opt.removeClass) {
          $(ci).replaceWith($(ci).html())
        }
        if (ci.tagName.toLowerCase() === 'strong' && opt.removeClass) {
          $(ci).replaceWith($(ci).html())
        }
      }
      if (html) {
        html.html = cont.innerHTML
      }

      // 清除所有空的p标签
      if (opt.removeEmptyNode) {
        var allPs = domUtils.getElementsByTagName(cont, '*')
        for (let i = 0, p; i < allPs.length; i++) {
          p = allPs[i]
          if (p.tagName.toLowerCase() === 'p') {
            if (!$(p).html()) {
              $(p).remove()
            }
          }
        }
      }
    }
    /**
     * 民族文主题下粘贴前去处理文本
     * @param {*} type 事件类型
     * @param {*} html 内容
     */
    function filterBeforePasteInNationalTheme(type, html) {
      if (!(opt.pasteFilter && opt.clearFontFamily)) {
        // 如果开启了粘贴过滤并且过滤了字体 则不再重复处理
        let me = this
        let cont // this是指UE.Editor,
        if (html) {
          cont = me.document.createElement('div')
          cont.innerHTML = html.html
        } else {
          cont = me.document.body // me是指UE.Editor
        }
        // 获取文章内容标签节点
        let nodes = domUtils.getElementsByTagName(cont, '*')
        for (var i = 0, ci; i < nodes.length; i++) {
          ci = nodes[i]
          // 过滤字体
          if (ci.style.fontFamily) {
            domUtils.removeStyle(ci, 'font-family')
            removeNotAttributeSpan(ci)
          }
        }
        // 处理完成之后 返回处理后的内容
        if (html) {
          html.html = cont.innerHTML
        }
      }
    }
    if (opt.pasteFilter) {
      me.addListener('beforepaste', autotype)
    }
    // 添加民族文的粘贴过滤
    if (nationalFontTheme) {
      me.addListener('beforepaste', filterBeforePasteInNationalTheme)
    }

    // 符号全转半
    function DBC2SB(str) {
      var result = ''
      for (var i = 0; i < str.length; i++) {
        var code = str.charCodeAt(i) // 获取当前字符的unicode编码
        // 在这个unicode编码范围中的是所有的英文字母已经各种字符
        if (
          (str.charCodeAt(i) >= 65281 && str.charCodeAt(i) <= 65312) ||
          (str.charCodeAt(i) <= 65344 && str.charCodeAt(i) >= 65339) ||
          (str.charCodeAt(i) >= 65371 && str.charCodeAt(i) < 65375)
        ) {
          result += String.fromCharCode(str.charCodeAt(i) - 65248) // 把全角字符的unicode编码转换为对应半角字符的unicode码
        } else if (code === 12288) {
          // 空格
          result += String.fromCharCode(str.charCodeAt(i) - 12288 + 32)
        } else {
          result += str.charAt(i)
        }
      }
      return result
    }
    // 符号 半转全
    function ToDBC(txtstring) {
      txtstring = utils.html(txtstring)
      var tmp = ''
      // var mark = ''
      /* 用于判断,如果是html尖括里的标记,则不进行全角的转换 */
      for (var i = 0; i < txtstring.length; i++) {
        if (txtstring.charCodeAt(i) === 34) {
          tmp += txtstring.charAt(i)
        } else if (txtstring.charCodeAt(i) === 32) {
          tmp = tmp + String.fromCharCode(12288)
        } else if (
          (txtstring.charCodeAt(i) >= 33 && txtstring.charCodeAt(i) <= 47) ||
          (txtstring.charCodeAt(i) >= 58 && txtstring.charCodeAt(i) <= 64) ||
          (txtstring.charCodeAt(i) <= 96 && txtstring.charCodeAt(i) >= 91) ||
          (txtstring.charCodeAt(i) >= 123 && txtstring.charCodeAt(i) < 127)
        ) {
          tmp = tmp + String.fromCharCode(txtstring.charCodeAt(i) + 65248)
        } else {
          tmp += txtstring.charAt(i)
        }
      }
      return tmp
    }
    // 20160714----------------
    // 字母 全转半
    function WORD_TOHALF(txtContent) {
      var result = ''
      for (var i = 0; i < txtContent.length; i++) {
        var code = txtContent.charCodeAt(i) // 获取当前字符的unicode编码
        // 在这个unicode编码范围中的是所有的英文字母
        if (
          (code >= 65313 && code <= 65338) ||
          (code >= 65345 && code <= 65370)
        ) {
          result += String.fromCharCode(txtContent.charCodeAt(i) - 65248) // 把全角字符的unicode编码转换为对应半角字符的unicode码
        } else if (code === 12288) {
          // 空格
          result += String.fromCharCode(txtContent.charCodeAt(i) - 12288 + 32)
        } else {
          result += txtContent.charAt(i)
        }
      }
      return result
    }

    // 字母 半转全
    function WORD_TOALL(txtContent) {
      txtContent = utils.html(txtContent)
      var tmp = ''
      // var mark = ''
      for (let i = 0; i < txtContent.length; i++) {
        /* 用于判断,如果是html尖括里的标记,则不进行全角的转换 */
        if (txtContent.charCodeAt(i) === 32) {
          tmp = tmp + String.fromCharCode(12288)
        } else if (
          (txtContent.charCodeAt(i) <= 122 && txtContent.charCodeAt(i) >= 97) ||
          (txtContent.charCodeAt(i) <= 90 && txtContent.charCodeAt(i) >= 65)
        ) {
          tmp = tmp + String.fromCharCode(txtContent.charCodeAt(i) + 65248)
        } else {
          tmp += txtContent.charAt(i)
        }
      }
      return tmp
    }

    function ToDBCNum(txtstring) {
      txtstring = utils.html(txtstring)
      var tmp = ''
      // var mark = ''
      /* 用于判断,如果是html尖括里的标记,则不进行全角的转换 */
      for (var i = 0; i < txtstring.length; i++) {
        if (txtstring.charCodeAt(i) === 32) {
          tmp = tmp + String.fromCharCode(12288)
        } else if (
          txtstring.charCodeAt(i) >= 48 &&
          txtstring.charCodeAt(i) <= 57
        ) {
          tmp = tmp + String.fromCharCode(txtstring.charCodeAt(i) + 65248)
        } else {
          tmp += txtstring.charAt(i)
        }
      }
      return tmp
    }

    function DBC2SBNum(str) {
      var result = ''
      for (var i = 0; i < str.length; i++) {
        var code = str.charCodeAt(i) // 获取当前字符的unicode编码
        // 在这个unicode编码范围中的是所有的英文字母已经各种字符
        if (code >= 65296 && code <= 65305) {
          result += String.fromCharCode(str.charCodeAt(i) - 65248) // 把全角字符的unicode编码转换为对应半角字符的unicode码
        } else if (code === 12288) {
          // 空格
          result += String.fromCharCode(str.charCodeAt(i) - 12288 + 32)
        } else {
          result += str.charAt(i)
        }
      }
      return result
    }

    function readLocalOpts() {
      var cookieOpt = me.getPreferences('autotypeset')
      utils.extend(me.options.autotypeset, cookieOpt)
    }

    me.commands['autotypeset'] = {
      execCommand: function () {
        me.removeListener('beforepaste', autotype)
        if (opt.pasteFilter) {
          me.addListener('beforepaste', autotype)
        }
        autotype.call(me)
      },
      queryCommandState: function () {
        return 0
      }
    }

    // f9一键排版快捷键
    me.addshortcutkey('autotypeset', '120')

    // 解决文字换段又backspace产生span line-height=1.5的bug
    // event === 'keydown'，未发现这段代码的作用
    me.on('keydown', function (event) {
      if (event.keyCode === 8 || event.keyCode === 46) {
        setTimeout(function () {
          var cont = me.document.body
          var nodes = domUtils.getElementsByTagName(cont, '*')
          for (let i = 0, ci; i < nodes.length; i++) {
            ci = nodes[i]
            if (ci.tagName.toLowerCase() === 'p') {
              $(ci)
                .find('span')
                .each(function () {
                  $(this).css({ 'line-height': '', 'text-indent': '' })
                })
            }
          }
        }, 100)
      }
    })
  }
}

// 查找替换 from翔宇之不能用
function searchreplace(UE) {
  UE.plugin.register('searchreplace', function () {
    var me = this
    var utils = UE.utils
    var dom = UE.dom
    var dtd = dom.dtd
    var browser = UE.browser
    var domUtils = UE.dom.domUtils
    var _blockElm = { table: 1, tbody: 1, tr: 1, ol: 1, ul: 1 }

    function findTextInString(textContent, opt, currentIndex) {
      var str = opt.searchStr
      if (opt.dir == -1) {
        textContent = textContent.split('').reverse().join('')
        str = str.split('').reverse().join('')
        currentIndex = textContent.length - currentIndex
      }
      var reg = new RegExp(str, 'g' + (opt.casesensitive ? '' : 'i')),
        match
      while ((match = reg.exec(textContent))) {
        if (match.index >= currentIndex) {
          return opt.dir == -1
            ? textContent.length - match.index - opt.searchStr.length
            : match.index
        }
      }
      return -1
    }
    function findTextBlockElm(node, currentIndex, opt) {
      var textContent,
        index,
        methodName =
          opt.all || opt.dir == 1 ? 'getNextDomNode' : 'getPreDomNode'
      if (domUtils.isBody(node)) {
        node = node.firstChild
      }
      var first = 1
      while (node) {
        textContent =
          node.nodeType == 3
            ? node.nodeValue
            : node[browser.ie ? 'innerText' : 'textContent']
        index = findTextInString(textContent, opt, currentIndex)
        first = 0
        if (index != -1) {
          return {
            node: node,
            index: index
          }
        }
        node = domUtils[methodName](node)
        while (node && _blockElm[node.nodeName.toLowerCase()]) {
          node = domUtils[methodName](node, true)
        }
        if (node) {
          currentIndex =
            opt.dir == -1
              ? (node.nodeType == 3
                  ? node.nodeValue
                  : node[browser.ie ? 'innerText' : 'textContent']
                ).length
              : 0
        }
      }
    }
    function findNTextInBlockElm(node, index, str) {
      var currentIndex = 0,
        currentNode = node.firstChild,
        currentNodeLength = 0,
        result
      while (currentNode) {
        if (currentNode.nodeType == 3) {
          currentNodeLength = currentNode.nodeValue.replace(
            /(^[\t\r\n]+)|([\t\r\n]+$)/,
            ''
          ).length
          currentIndex += currentNodeLength
          if (currentIndex >= index) {
            return {
              node: currentNode,
              index: currentNodeLength - (currentIndex - index)
            }
          }
        } else if (!dtd.$empty[currentNode.tagName]) {
          currentNodeLength = currentNode[
            browser.ie ? 'innerText' : 'textContent'
          ].replace(/(^[\t\r\n]+)|([\t\r\n]+$)/, '').length
          currentIndex += currentNodeLength
          if (currentIndex >= index) {
            result = findNTextInBlockElm(
              currentNode,
              currentNodeLength - (currentIndex - index),
              str
            )
            if (result) {
              return result
            }
          }
        }
        currentNode = domUtils.getNextDomNode(currentNode)
      }
    }
    function searchReplace(me, opt) {
      var rng = me.selection.getRange(),
        startBlockNode,
        searchStr = opt.searchStr,
        span = me.document.createElement('span')
      span.innerHTML = '$$ueditor_searchreplace_key$$'
      rng.shrinkBoundary(true)

      //判断是不是第一次选中
      if (!rng.collapsed) {
        rng.select()
        var rngText = me.selection.getText()
        if (
          new RegExp(
            '^' + opt.searchStr + '$',
            opt.casesensitive ? '' : 'i'
          ).test(rngText)
        ) {
          if (opt.replaceStr != undefined) {
            replaceText(rng, opt.replaceStr)
            rng.select()
            return true
          } else {
            rng.collapse(opt.dir == -1)
          }
        }
      }

      rng.insertNode(span)
      rng.enlargeToBlockElm(true)
      startBlockNode = rng.startContainer
      var currentIndex = startBlockNode[
        browser.ie ? 'innerText' : 'textContent'
      ].indexOf('$$ueditor_searchreplace_key$$')
      rng.setStartBefore(span)
      domUtils.remove(span)
      var result = findTextBlockElm(startBlockNode, currentIndex, opt)
      if (result) {
        var rngStart = findNTextInBlockElm(result.node, result.index, searchStr)
        var rngEnd = findNTextInBlockElm(
          result.node,
          result.index + searchStr.length,
          searchStr
        )
        rng
          .setStart(rngStart.node, rngStart.index)
          .setEnd(rngEnd.node, rngEnd.index)
        if (opt.replaceStr !== undefined) {
          replaceText(rng, opt.replaceStr)
        }
        rng.select()
        // 滚动到对应区域
        result.node.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'start'
        })

        return true
      } else {
        rng.setCursor()
      }
    }
    function replaceText(rng, str) {
      str = me.document.createTextNode(str)
      rng.deleteContents().insertNode(str)
    }
    return {
      commands: {
        searchreplace: {
          execCommand: function (cmdName, opt) {
            utils.extend(
              opt,
              {
                all: false,
                casesensitive: false,
                dir: 1
              },
              true
            )
            var num = 0
            if (opt.all) {
              var rng = me.selection.getRange(),
                first = me.body.firstChild
              if (first && first.nodeType == 1) {
                rng.setStart(first, 0)
                rng.shrinkBoundary(true)
              } else if (first.nodeType == 3) {
                rng.setStartBefore(first)
              }
              rng.collapse(true).select(true)
              if (opt.replaceStr !== undefined) {
                me.fireEvent('saveScene')
              }
              while (searchReplace(this, opt)) {
                num++
              }
              if (num) {
                me.fireEvent('saveScene')
              }
            } else {
              if (opt.replaceStr !== undefined) {
                me.fireEvent('saveScene')
              }
              if (searchReplace(this, opt)) {
                num++
              }
              if (num) {
                me.fireEvent('saveScene')
              }
            }
            return num
          },
          notNeedUndo: 1
        }
      }
    }
  })
}
function anchor(UE) {
  var utils = UE.utils
  var domUtils = UE.dom.domUtils
  UE.plugin.register('anchor', function () {
    return {
      bindEvents: {
        ready: function () {
          utils.cssRule(
            'anchor',
            '.anchorclass{background: url(data:image/gif;base64,R0lGODlhEAAPALMJAJaWloCAAP//mf///8z/AJmZAP//zDMzAMzMAP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAAkALAAAAAAQAA8AAARlMElp0EEzI8PrKAWHIMWRbAMXlAExFoGJcoKFuGQMzEZ94bDDzpDq2YA6nu/2St4IxouAQAjuRgHEkoQIOC/MrO1Q2lUH4NLBSxaeiJXDelUtTza1laEac2v2XXJCABkZggCEExEAOw==) no-repeat scroll left center transparent;cursor: auto!important;display: inline-block;height: 16px!important;width: 15px;vertical-align: middle;}',
            this.document
          )
        }
      },
      outputRule: function (root) {
        utils.each(root.getNodesByTagName('img'), function (a) {
          var val
          if ((val = a.getAttr('anchorname'))) {
            a.tagName = 'a'
            a.setAttr({
              anchorname: '',
              name: val,
              class: ''
            })
          }
        })
      },
      inputRule: function (root) {
        utils.each(root.getNodesByTagName('a'), function (a) {
          var val
          if ((val = a.getAttr('name')) && !a.getAttr('href')) {
            a.tagName = 'img'
            a.setAttr({
              anchorname: a.getAttr('name'),
              class: 'anchorclass'
            })
            a.setAttr('name')
          }
        })
      },
      commands: {
        /**
         * 插入锚点
         * @command anchor
         * @method execCommand
         * @param { String } cmd 命令字符串
         * @param { String } name 锚点名称字符串
         * @example
         * ```javascript
         * //editor 是编辑器实例
         * editor.execCommand('anchor', 'anchor1');
         * ```
         */
        anchor: {
          execCommand: function (cmd, name) {
            var range = this.selection.getRange(),
              img = range.getClosedNode()
            if (img && img.getAttribute('anchorname')) {
              if (name) {
                img.setAttribute('anchorname', name)
              } else {
                range.setStartBefore(img).setCursor()
                domUtils.remove(img)
              }
            } else {
              if (name) {
                //只在选区的开始插入
                var anchor = this.document.createElement('img')
                range.collapse(true)
                domUtils.setAttributes(anchor, {
                  id:
                    'a' +
                    parseInt(
                      Math.random() * (9999999999 - 1000000000 + 1) + 1000000000
                    ),

                  anchorname: name,
                  class: 'anchorclass'
                })
                range
                  .insertNode(anchor)
                  .setStartAfter(anchor)
                  .setCursor(false, true)
              }
            }
          }
        }
      }
    }
  })
}
function autoupload(UE) {
  var utils = UE.utils
  var dom = UE.dom
  var domUtils = UE.dom.domUtils
  UE.plugin.register('autoupload', function () {
    function sendAndInsertFile(file, editor) {
      var me = editor
      //模拟数据
      var fieldName,
        urlPrefix,
        maxSize,
        allowFiles,
        actionUrl,
        loadingHtml,
        errorHandler,
        successHandler,
        filetype = /image\/\w+/i.test(file.type) ? 'image' : 'file',
        loadingId = 'loading_' + (+new Date()).toString(36)

      fieldName = me.getOpt(filetype + 'FieldName')
      urlPrefix = me.getOpt(filetype + 'UrlPrefix')
      maxSize = me.getOpt(filetype + 'MaxSize')
      allowFiles = me.getOpt(filetype + 'AllowFiles')
      // actionUrl = me.getActionUrl(me.getOpt(filetype + 'ActionName'));
      actionUrl = '/mediax-image/photo/downloadScreenshot'
      if (window.processEnvMode == 'PUGC') {
        actionUrl = pugc_ueditor_conf.actionUrl
      }
      errorHandler = function (title) {
        var loader = me.document.getElementById(loadingId)
        loader && domUtils.remove(loader)
        me.fireEvent('showmessage', {
          id: loadingId,
          content: title,
          type: 'error',
          timeout: 4000
        })
      }

      if (filetype == 'image') {
        loadingHtml =
          '<img class="loadingclass" id="' +
          loadingId +
          '" src="' +
          me.options.themePath +
          me.options.theme +
          '/images/placeholderNew.gif" title="' +
          (me.getLang('autoupload.loading') || '') +
          '" >'
        successHandler = function (path) {
          // var link = urlPrefix + data.url,
          var loader = me.document.getElementById(loadingId)
          /* if (loader) {
              loader.setAttribute('src', link);
              loader.setAttribute('_src', link);
              loader.setAttribute('title', data.title || '');
              loader.setAttribute('alt', data.original || '');
              loader.removeAttribute('id');
              domUtils.removeClasses(loader, 'loadingclass');
          } */

          if (loader) {
            if (window.processEnvMode == 'PUGC') {
              pugc_ueditor_conf.path2url(domUtils, loader, path, me)
            } else {
              e5.getE5ImageUrl({
                params: { devicePath: path }
              }).then((res1) => {
                let url = res1.data.url,
                  id =
                    'yq' +
                    parseInt(
                      Math.random() * (9999999999 - 1000000000 + 1) + 1000000000
                    )

                domUtils.removeAttributes(loader, ['_src', 'title'])
                domUtils.setAttributes(loader, {
                  mam: path,
                  src: url,
                  url: url,
                  id: id
                })

                domUtils.removeClasses(loader, 'loadingclass')
                me.fireEvent('autoupload', {
                  path: path,
                  mam: path,
                  src: url,
                  url: url,
                  id: id
                })
                me.execCommand('autosettitleimage', path)
              })
            }
          }
        }
      } else {
        loadingHtml =
          '<p>' +
          '<img class="loadingclass" id="' +
          loadingId +
          '" src="' +
          me.options.themePath +
          me.options.theme +
          '/images/spacer.gif" title="' +
          (me.getLang('autoupload.loading') || '') +
          '" >' +
          '</p>'
        successHandler = function (data) {
          var link = urlPrefix + data.url,
            loader = me.document.getElementById(loadingId)

          var rng = me.selection.getRange(),
            bk = rng.createBookmark()
          rng.selectNode(loader).select()
          me.execCommand('insertfile', { url: link })
          rng.moveToBookmark(bk).select()
        }
      }

      /* 插入loading的占位符 */
      me.execCommand('inserthtml', loadingHtml)

      /* 判断后端配置是否没有加载成功 */
      if (!me.getOpt(filetype + 'ActionName')) {
        errorHandler(me.getLang('autoupload.errorLoadConfig'))
        return
      }
      /* 判断文件大小是否超出限制 */
      if (file.size > maxSize) {
        errorHandler(me.getLang('autoupload.exceedSizeError'))
        return
      }
      /* 判断文件格式是否超出允许 */
      var fileext = file.name
        ? file.name.substr(file.name.lastIndexOf('.'))
        : ''
      if (
        (fileext && filetype != 'image') ||
        (allowFiles &&
          (allowFiles.join('') + '.').indexOf(fileext.toLowerCase() + '.') ==
            -1)
      ) {
        errorHandler(me.getLang('autoupload.exceedTypeError'))
        return
      }
      let loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
      /* 创建Ajax并提交 */
      var xhr = new XMLHttpRequest(),
        fd = new FormData(),
        params =
          utils.serializeParam(me.queryCommandValue('serverparam')) || '',
        url = utils.formatUrl(
          actionUrl + (actionUrl.indexOf('?') == -1 ? '?' : '&') + params
        )
      const dn = getRandom11DigitNumber()
      fd.append(
        'file',
        file,
        file.name || 'blob.' + file.type.substr('image/'.length)
      )
      fd.append('dn', dn)
      let d = new Date().getTime()
      if (window.localStorage.getItem('yqSystemTime')) {
        d = Number(d) + Number(window.localStorage.getItem('yqSystemTime'))
      }


      let MediaxSecurity = md5(loginInfo.userCode + '.' + d) + ';' + d
      let newParams = `dn=${dn}&Mediaxsecurity=${MediaxSecurity}`
      const newMediaxSecurity = MediaxSecurity + ';' + sm3(newParams)
      xhr.open('post', url, true)
      if (window.processEnvMode != 'PUGC') {
        xhr.setRequestHeader('MediaxAuth', loginInfo.authToken)
        xhr.setRequestHeader('MediaxSecurity', newMediaxSecurity)
      } else {
        store.dispatch('batman/GET_TICKET')
        xhr.setRequestHeader('s-token', loginInfo.authToken)
        xhr.setRequestHeader('Ticket', store.state.batman.Ticket)
        xhr.setRequestHeader('source', 'batman')
      }
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
      xhr.addEventListener('load', function (e) {
        try {
          var json = new Function('return ' + utils.trim(e.target.response))()
          if (json.status === 0 && json.data.path) {
            successHandler(json.data.path)
          } else {
            errorHandler(json.state)
          }
        } catch (er) {
          errorHandler(me.getLang('autoupload.loadError'))
        }
      })
      xhr.send(fd)
    }

    function getPasteImage(e) {
      return e.clipboardData &&
        e.clipboardData.items &&
        e.clipboardData.items.length == 1 &&
        /^image\//.test(e.clipboardData.items[0].type)
        ? e.clipboardData.items
        : null
    }
    function getDropImage(e) {
      return e.dataTransfer && e.dataTransfer.files
        ? e.dataTransfer.files
        : null
    }

    return {
      outputRule: function (root) {
        utils.each(root.getNodesByTagName('img'), function (n) {
          if (
            /\b(loaderrorclass)|(bloaderrorclass)\b/.test(n.getAttr('class'))
          ) {
            n.parentNode.removeChild(n)
          }
        })
        utils.each(root.getNodesByTagName('p'), function (n) {
          if (/\bloadpara\b/.test(n.getAttr('class'))) {
            n.parentNode.removeChild(n)
          }
        })
      },
      bindEvents: {
        //插入粘贴板的图片，拖放插入图片
        ready: function (e) {
          var me = this
          if (window.FormData && window.FileReader) {
            domUtils.on(me.body, 'paste drop', function (e) {
              var hasImg = false,
                items
              //获取粘贴板文件列表或者拖放文件列表
              items = e.type == 'paste' ? getPasteImage(e) : getDropImage(e)
              if (items) {
                var len = items.length,
                  file
                while (len--) {
                  file = items[len]
                  if (file.getAsFile) file = file.getAsFile()
                  if (file && file.size > 0 && file.name != 'spacer.gif') {
                    sendAndInsertFile(file, me)
                    hasImg = true
                  }
                }
                hasImg && e.preventDefault()
              }
            })
            //取消拖放图片时出现的文字光标位置提示
            domUtils.on(me.body, 'dragover', function (e) {
              if (e.dataTransfer.types[0] == 'Files') {
                e.preventDefault()
              }
            })

            //设置loading的样式
            utils.cssRule(
              'loading',
              '.loadingclass{display:inline-block;cursor:default;margin-left:1px;height: 150px;width: 150px;}\n' +
                ".loaderrorclass{display:inline-block;cursor:default;background: url('" +
                this.options.themePath +
                this.options.theme +
                "/images/loaderror.png') no-repeat center center transparent;border:1px solid #cccccc;margin-right:1px;height: 22px;width: 22px;" +
                '}',
              this.document
            )
          }
        }
      }
    }
  })
}

/**
 * 换段转换行 create by wanzj 20190723
 */
function br2p(UE) {
  UE.plugins['br2p'] = function () {
    var me = this
    me.commands['br2p'] = {
      execCommand: function () {
        var range = me.selection.getRange()
        // 获取当前位置的开始节点和结束节点
        if (range.collapsed) {
          alert('请选择内容!')
        } else {
          range.enlarge(true)
          var fragment = range.cloneContents()
          if (
            !fragment ||
            (fragment.firstChild === fragment.lastChild &&
              fragment.firstChild.tagName === 'IMG')
          ) {
            return false
          } else {
            range.deleteContents()
          }
          var divDom = document.createElement('div')
          divDom.appendChild(fragment)
          // var brNodes = domUtils.getElementsByTagName(divDom, 'br');
          var needInitTooltip = false
          $(divDom)
            .find('img[data-original-title] + div.tooltip')
            .each(function () {
              $(this).remove()
              needInitTooltip = true
            })
          var _html = divDom.innerHTML
          _html = _html
            .replace(/<[\s]*[\/]*br[^>]*>/gim, '<br/>')
            .replace(/<[\s]*\/[\s]*p>/gim, '</p>')
            .replace(/<br\/>[\s]*<\/p>[\s]*/gim, '</p>')
            .replace(/<br\/>/gim, '</p><p>')

          me.focus()
          me.execCommand('inserthtml', _html)
          // channel_frame && typeof channel_frame.tooltipInit === 'function' && needInitTooltip && channel_frame.tooltipInit();
          me.fireEvent('saveScene')
        }
      }
    }
    // if (specialTextFormat === 1) {
    // 	me.commands['change_br_to_p'] = me.commands['br2p'];
    // }
  }
}
// 换行转换段
function p2br(UE) {
  UE.plugins['p2br'] = function () {
    var me = this
    me.commands['p2br'] = {
      execCommand: function () {
        var range = me.selection.getRange()
        if (range.collapsed) {
          alert('请选择内容!')
        } else {
          range.enlarge(true)
          var fragment = range.cloneContents()
          if (
            !fragment ||
            (fragment.firstChild === fragment.lastChild &&
              fragment.firstChild.tagName === 'IMG')
          ) {
            return false
          } else {
            range.deleteContents()
          }
          var divDom = document.createElement('div')
          divDom.appendChild(fragment)
          var needInitTooltip = false
          $(divDom)
            .find('img[data-original-title] + div.tooltip')
            .each(function () {
              $(this).remove()
              needInitTooltip = true
            })
          var _html = divDom.innerHTML
          _html = _html
            .replace(/<[\s]*[\/]*br[^>]*>/gim, '<br/>')
            .replace(
              /(<br\/>)*<[\s]*[\/]*p[\s]*>[\s]*<[\s]*p[^>]*>/gim,
              '<br/>'
            )
          me.focus()
          me.execCommand('inserthtml', _html, true)
          // channel_frame && typeof channel_frame.tooltipInit === 'function' && needInitTooltip && channel_frame.tooltipInit();
          me.fireEvent('saveScene')
        }
      }
    }
    // if (specialTextFormat === 1) {
    // 	me.commands['change_p_to_br'] = me.commands['p2br'];
    // }
  }
}
/* 添加了插入时将当前选中的内容替换逻辑（好可怕替换掉全选的内容 */
function inserthtml(UE) {
  var utils = UE.utils
  var dom = UE.dom
  var dtd = dom.dtd
  var browser = UE.browser
  var domUtils = UE.dom.domUtils
  var fillCharReg = (dom.fillCharReg = new RegExp(domUtils.fillChar, 'g'))

  UE.commands['inserthtml'] = {
    execCommand: function (command, html, notNeedFilter) {
      var me = this,
        range,
        div

      if (!html) {
        return
      }

      if (me.fireEvent('beforeinserthtml', html) === true) {
        return
      }
      range = me.selection.getRange()
      div = range.document.createElement('div')
      div.style.display = 'inline'

      if (!notNeedFilter) {
        var root = UE.htmlparser(html)
        //如果给了过滤规则就先进行过滤
        if (me.options.filterRules) {
          UE.filterNode(root, me.options.filterRules)
        }
        //执行默认的处理
        me.filterInputRule(root)
        html = root.toHtml()
      }

      div.innerHTML = utils.trim(html)

      if (!range.collapsed) {
        var tmpNode = range.startContainer
        if (domUtils.isFillChar(tmpNode)) {
          range.setStartBefore(tmpNode)
        }
        tmpNode = range.endContainer
        if (domUtils.isFillChar(tmpNode)) {
          range.setEndAfter(tmpNode)
        }
        range.txtToElmBoundary()
        //结束边界可能放到了br的前边，要把br包含进来
        // x[xxx]<br/>
        if (range.endContainer && range.endContainer.nodeType == 1) {
          tmpNode = range.endContainer.childNodes[range.endOffset]
          if (tmpNode && domUtils.isBr(tmpNode)) {
            range.setEndAfter(tmpNode)
          }
        }
        if (range.startOffset == 0) {
          tmpNode = range.startContainer
          if (domUtils.isBoundaryNode(tmpNode, 'firstChild')) {
            tmpNode = range.endContainer
            if (
              range.endOffset ==
                (tmpNode.nodeType == 3
                  ? tmpNode.nodeValue.length
                  : tmpNode.childNodes.length) &&
              domUtils.isBoundaryNode(tmpNode, 'lastChild')
            ) {
              me.body.innerHTML = '<p>' + (browser.ie ? '' : '<br/>') + '</p>'
              range.setStart(me.body.firstChild, 0).collapse(true)
            }
          }
        }
        !range.collapsed && range.deleteContents()
        if (range.startContainer.nodeType == 1) {
          var child = range.startContainer.childNodes[range.startOffset],
            pre
          if (
            child &&
            domUtils.isBlockElm(child) &&
            (pre = child.previousSibling) &&
            domUtils.isBlockElm(pre)
          ) {
            range.setEnd(pre, pre.childNodes.length).collapse()
            while (child.firstChild) {
              pre.appendChild(child.firstChild)
            }
            domUtils.remove(child)
          }
        }
      }

      var child,
        parent,
        pre,
        tmp,
        hadBreak = 0,
        nextNode
      //如果当前位置选中了fillchar要干掉，要不会产生空行
      if (range.inFillChar()) {
        child = range.startContainer
        domUtils.trimWhiteTextNode(child)

        if (domUtils.isFillChar(child)) {
          range.setStartBefore(child).collapse(true)
          domUtils.remove(child)
        } else if (domUtils.isFillChar(child, true)) {
          child.nodeValue = child.nodeValue.replace(fillCharReg, '')
          range.startOffset--
          range.collapsed && range.collapse(true)
        }
      }
      //列表单独处理
      var li = domUtils.findParentByTagName(range.startContainer, 'li', true)
      if (li) {
        var next, last
        while ((child = div.firstChild)) {
          //针对hr单独处理一下先
          while (
            child &&
            (child.nodeType == 3 ||
              !domUtils.isBlockElm(child) ||
              child.tagName == 'HR')
          ) {
            next = child.nextSibling
            range.insertNode(child).collapse()
            last = child
            child = next
          }
          if (child) {
            if (/^(ol|ul)$/i.test(child.tagName)) {
              while (child.firstChild) {
                last = child.firstChild
                domUtils.insertAfter(li, child.firstChild)
                li = li.nextSibling
              }
              domUtils.remove(child)
            } else {
              var tmpLi
              next = child.nextSibling
              tmpLi = me.document.createElement('li')
              domUtils.insertAfter(li, tmpLi)
              tmpLi.appendChild(child)
              last = child
              child = next
              li = tmpLi
            }
          }
        }
        li = domUtils.findParentByTagName(range.startContainer, 'li', true)
        if (domUtils.isEmptyBlock(li)) {
          domUtils.remove(li)
        }
        if (last) {
          range.setStartAfter(last).collapse(true).select(true)
        }
      } else {
        while ((child = div.firstChild)) {
          if (hadBreak) {
            var p = me.document.createElement('p')
            while (
              child &&
              (child.nodeType == 3 || !dtd.$block[child.tagName])
            ) {
              nextNode = child.nextSibling
              p.appendChild(child)
              child = nextNode
            }
            if (p.firstChild) {
              child = p
            }
          }

          range.insertNode(child)
          nextNode = child.nextSibling
          if (
            !hadBreak &&
            child.nodeType == domUtils.NODE_ELEMENT &&
            domUtils.isBlockElm(child)
          ) {
            parent = domUtils.findParent(child, function (node) {
              return domUtils.isBlockElm(node)
            })

            if (
              parent &&
              parent.tagName.toLowerCase() != 'body' &&
              !(
                dtd[parent.tagName] &&
                dtd[parent.tagName][child.nodeName] &&
                child.parentNode === parent
              )
            ) {
              if (
                !dtd[parent.tagName] ||
                !dtd[parent.tagName][child.nodeName]
              ) {
                pre = parent
              } else {
                tmp = domUtils.trimWhiteTextNode(child.parentNode)
                while (tmp !== parent) {
                  pre = tmp
                  tmp = tmp.parentNode
                }
              }
              domUtils.breakParent(child, pre || tmp)
              //去掉break后前一个多余的节点  <p>|<[p> ==> <p></p><div></div><p>|</p>

              var pre = child.previousSibling
              domUtils.trimWhiteTextNode(pre)

              if (!pre.childNodes.length) {
                domUtils.remove(pre)
              }
              //trace:2012,在非ie的情况，切开后剩下的节点有可能不能点入光标添加br占位

              if (
                !browser.ie &&
                (next = child.nextSibling) &&
                domUtils.isBlockElm(next) &&
                next.lastChild &&
                !domUtils.isBr(next.lastChild)
              ) {
                next.appendChild(me.document.createElement('br'))
              }
              hadBreak = 1
            }
          }
          var next = child.nextSibling
          if (!div.firstChild && next && domUtils.isBlockElm(next)) {
            range.setStart(next, 0).collapse(true)
            break
          }
          range.setEndAfter(child).collapse()
        }

        child = range.startContainer

        if (nextNode && domUtils.isBr(nextNode)) {
          domUtils.remove(nextNode)
        }
        //用chrome可能有空白展位符
        if (domUtils.isBlockElm(child) && domUtils.isEmptyNode(child)) {
          if ((nextNode = child.nextSibling)) {
            domUtils.remove(child)
            if (nextNode.nodeType == 1 && dtd.$block[nextNode.tagName]) {
              range.setStart(nextNode, 0).collapse(true).shrinkBoundary()
            }
          } else {
            try {
              child.innerHTML = browser.ie ? domUtils.fillChar : '<br/>'
            } catch (e) {
              range.setStartBefore(child)
              domUtils.remove(child)
            }
          }
        }
        //加上true因为在删除表情等时会删两次，第一次是删的fillData
        try {
          range.select(true)
        } catch (e) {}
      }

      /**
       * 修改编辑器内容时，调用音频监听方法，防止多个视频同时播放
       */
      me.audioPause()

      setTimeout(function () {
        range = me.selection.getRange()
        range.scrollToView(
          me.autoHeightEnabled,
          me.autoHeightEnabled ? domUtils.getXY(me.iframe).y : 0
        )
        me.fireEvent('afterinserthtml', html)
      }, 200)
    }
  }
}
function loadCustomUE(customConfig) {
  if (window.processEnvMode != 'PUGC') {
    MediaCloudGateway.getPortals()
      .then((res) => {
        let crossCode = res.data.data.auth.find(
          (item) => item.code === 'crossmodal'
        )
        if (crossCode) {
          localStorage.setItem('crossModalFlag', JSON.stringify(crossCode))
        } else {
          localStorage.removeItem('crossModalFlag')
        }
      })
      .catch((error) => {
        console.error('Error loading portals:', error)
        // 这里可以处理错误，比如清除localStorage中的crossModalFlag
        localStorage.removeItem('crossModalFlag')
      })
  }
  // // 配置编辑器内选中图片后智能人物识别功能按钮的展示
  window.UE.showPopupTitlePic = true // 选中图片时是否显示‘设为标题图片’按钮
  window.UE.showPopupPhotoSearch = false // 选中图片时是否显示‘智能人物识别’按钮
  window.UE.showPopupReplace = true // 选中图片时是否显示‘换图’按钮
  window.UE.showPopupModify = true // 选中图片时是否显示‘修改’按钮
  window.UE.showForComment = true // 选中图片时是否显示‘设置图说’按钮
  let crossModalFlag = localStorage.getItem('crossModalFlag')
  if (crossModalFlag) {
    let parsedCrossModalFlag = JSON.parse(crossModalFlag)
    let editerFounderAIImageIndexSwitch =
      parsedCrossModalFlag.expire !== 'true' ? true : false
    window.UE.showPopupImgSearch = editerFounderAIImageIndexSwitch // 选中图片时是否显示‘智能识图’按钮
  }
  // let editerFounderAIImageIndexSwitch =
  //   window.localStorage.getItem('crossModalFlag').expire !== 'true'
  //     ? true
  //     : false
  // window.UE.showPopupImgSearch = editerFounderAIImageIndexSwitch // 选中图片时是否显示‘智能识图’按钮
  window.audios = [] // 作用不清楚
  let UE = window.UE
  registerUIList(UE, customConfig)
  // searchreplace(UE) // 不要打开 翔宇和采编的替换的不能拿到云雀用！！
  anchor(UE) // 锚点（135已弃用 自我折磨中
  autoTypeSet(UE)
  inserthtml(UE)
  customCommands(UE)
  customPlugins(UE, customConfig)
  autoupload(UE)
  br2p(UE) // 换段转换行
  p2br(UE) // 换行转换段
}

// pugc的配置
const pugc_ueditor_conf = {
  actionUrl: '/prebatman/batman/article/uploadImage',
  path2url: (domUtils, loader, path, me) => {
    MediacloudReporter.getImageUrl({
      params: { devicePath: path }
    }).then((res1) => {
      let url = res1.data.data,
        id =
          'yq' +
          parseInt(Math.random() * (9999999999 - 1000000000 + 1) + 1000000000)

      domUtils.removeAttributes(loader, ['_src', 'title'])
      domUtils.setAttributes(loader, {
        mam: path,
        src: url,
        url: url,
        id: id
      })

      domUtils.removeClasses(loader, 'loadingclass')
      me.fireEvent('autoupload', {
        path: path,
        mam: path,
        src: url,
        url: url,
        id: id
      })
    })
  }
}

export default { loadCustomUE }
